"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  AddIcon: () => AddIcon_default,
  AirBalloonIllustration: () => AirBalloonIllustration_default,
  AllyIcon: () => AllyIcon_default,
  AmountInput: () => AmountInput,
  ArrowBackIcon: () => ArrowBackIcon_default,
  ArrowIcon: () => ArrowIcon_default,
  AvilaIcon: () => AvilaIcon_default,
  BagIcon: () => BagIcon_default,
  BankIcon: () => BankIcon_default,
  BlockIcon: () => BlockIcon_default,
  BookIcon: () => BookIcon_default,
  Button: () => Button,
  CalendarIcon: () => CalendarIcon_default,
  Card: () => card_default,
  CardCarouselWrapper: () => CardCarouselWrapper_default,
  CardIcon: () => CardIcon_default,
  CategoryIcon: () => CategoryIcon_default,
  CheckEmptyIcon: () => CheckEmptyIcon_default,
  CheckFullIcon: () => CheckFullIcon_default,
  ClientOnlyPortal: () => ClientOnlyPortal,
  CloseIcon: () => CloseIcon_default,
  CollapsibleArrow: () => CollapsibleArrow_default,
  CompanyIcon: () => CompanyIcon_default,
  DashboardIcon: () => DashboardIcon_default,
  DateInput: () => DateInput,
  DeleteIcon: () => DeleteIcon_default,
  DniInput: () => DniInput,
  DollarIcon: () => DollarIcon_default,
  DotIcon: () => DotIcon_default,
  EditIcon: () => EditIcon_default,
  EmptyIllustration: () => EmptyIllustration_default,
  ExitIcon: () => ExitIcon_default,
  EyeIcon: () => EyeIcon_default,
  FullListIcon: () => FullListIcon_default,
  GoalIcon: () => GoalIcon_default,
  HeartIcon: () => HeartIcon_default,
  HomeIcon: () => HomeIcon_default,
  InfoIcon: () => InfoIcon_default,
  Input: () => Input,
  InventoryIcon: () => InventoryIcon_default,
  LinkedinIcon: () => LinkedinIcon_default,
  Loading: () => Loading_default,
  LocalOfferIcon: () => LocalOfferIcon_default,
  LocationIcon: () => LocationIcon_default,
  LockIcon: () => LockIcon_default,
  LogoutIcon: () => LogoutIcon_default,
  MailIcon: () => MailIcon_default,
  MenuIcon: () => MenuIcon_default,
  MinusIcon: () => MinusIcon_default,
  Modal: () => modal_default,
  MoneyIcon: () => MoneyIcon_default,
  MultipleSelect: () => MultipleSelect,
  PageIcon: () => PageIcon_default,
  PencilIcon: () => PencilIcon_default,
  PhoneIcon: () => PhoneIcon_default,
  PhotoIcon: () => PhotoIcon_default,
  PlanIcon: () => PlanIcon_default,
  QuantityInput: () => QuantityInput_default,
  RefreshIcon: () => RefreshIcon_default,
  RemoveIcon: () => RemoveIcon_default,
  SaleIcon: () => SaleIcon_default,
  SearchIcon: () => SearchIcon_default,
  Select: () => Select,
  SendIcon: () => SendIcon_default,
  SettingsIcon: () => SettingsIcon_default,
  ShoppingCarIcon: () => ShoppingCarIcon_default,
  SpinnerIcon: () => SpinnerIcon_default,
  StarIcon: () => StarIcon_default,
  SubscriptionIcon: () => SubscriptionIcon_default,
  SupervisorIcon: () => SupervisorIcon_default,
  Table: () => table_default,
  TableIcon: () => TableIcon_default,
  TagsInput: () => TagsInput_default,
  TextArea: () => TextArea,
  ThanksIcon: () => ThanksIcon_default,
  TimerIcon: () => TimerIcon_default,
  Toast: () => Toast,
  ToastCloseIcon: () => ToastCloseIcon_default2,
  ToastErrorIcon: () => ToastErrorIcon_default2,
  ToastSuccessIcon: () => ToastSuccessIcon_default2,
  TrashIcon: () => TrashIcon_default,
  UnLoggedLayout: () => UnLoggedLayout_default,
  UpdateIcon: () => UpdateIcon_default,
  UploadIcon: () => UploadIcon_default,
  UploadImageIcon: () => UploadImageIcon_default,
  UserIcon: () => UserIcon_default,
  VerifiedUserIcon: () => VerifiedUserIcon_default,
  WEEK_DAYS: () => WEEK_DAYS,
  WalletIcon: () => WalletIcon_default,
  WhatsAppIcon: () => WhatsAppIcon_default,
  calculatePagination: () => calculatePagination,
  formatCurrency: () => formatCurrency,
  getNextMonth: () => getNextMonth,
  getPreviousMonth: () => getPreviousMonth,
  months: () => months,
  refactorDate: () => refactorDate,
  useRefDimensions: () => useRefDimensions_default,
  useScreenSize: () => useScreenSize_default
});
module.exports = __toCommonJS(src_exports);

// src/portal/Portal.tsx
var import_react = require("react");
var import_react_dom = require("react-dom");
function ClientOnlyPortal({
  children,
  selector
}) {
  const ref = (0, import_react.useRef)(null);
  const [mounted, setMounted] = (0, import_react.useState)(false);
  (0, import_react.useEffect)(() => {
    ref.current = document.querySelector(selector);
    setMounted(true);
  }, [selector]);
  return mounted && ref.current ? (0, import_react_dom.createPortal)(children, ref.current) : null;
}

// src/toast/icons/ToastCloseIcon.tsx
var import_jsx_runtime = require("react/jsx-runtime");
function ToastCloseIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "currentColor",
      viewBox: "0 0 20 20",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          fillRule: "evenodd",
          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
          clipRule: "evenodd"
        }
      )
    })
  );
}
var ToastCloseIcon_default = ToastCloseIcon;

// src/toast/icons/ToastErrorIcon.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
function ToastErrorIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
        }
      )
    })
  );
}
var ToastErrorIcon_default = ToastErrorIcon;

// src/toast/icons/ToastSuccessIcon.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
function ToastSuccessIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        }
      )
    })
  );
}
var ToastSuccessIcon_default = ToastSuccessIcon;

// src/toast/Toast.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
function Toast(_a) {
  var _b = _a, {
    type = "info",
    id = "",
    onDelete,
    children
  } = _b, rest = __objRest(_b, [
    "type",
    "id",
    "onDelete",
    "children"
  ]);
  switch (type) {
    case "success":
      return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
        "div",
        __spreadProps(__spreadValues({
          className: "max-w-xs mb-3 bg-green-500 rounded text-white w-full mx-auto px-4 py-2",
          role: "alert",
          style: { zIndex: 200 }
        }, rest), {
          children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "w-full flex flex-row flex-wrap", children: [
            /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "w-6 h-6 flex m-auto", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(ToastSuccessIcon_default, { className: "w-6 h-6 m-auto text-white" }) }),
            /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "flex flex-row flex-wrap flex-grow pl-1", children: [
              /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("span", { className: "w-full flex flex-row flex-wrap", children: [
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { className: "font-semibold text-white", children: "\xA1\xC9xito!" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                  "button",
                  {
                    "aria-label": "Close",
                    type: "button",
                    className: "ml-auto p-0 bg-transparent focus:outline-none outline-none",
                    "data-id": id,
                    onClick: onDelete,
                    children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(ToastCloseIcon_default, { className: "w-4 h-4" })
                  }
                )
              ] }),
              typeof children === "string" ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { className: "text-sm", children }) : children
            ] })
          ] })
        })
      );
    case "error":
      return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
        "div",
        __spreadProps(__spreadValues({
          className: "max-w-xs mb-3 bg-red-500 rounded text-white w-full mx-auto px-4 py-2",
          role: "alert",
          style: { zIndex: 200 }
        }, rest), {
          children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "w-full flex flex-row flex-wrap", children: [
            /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "w-6 h-6 flex m-auto", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(ToastErrorIcon_default, { className: "w-6 h-6 text-white m-auto" }) }),
            /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "flex flex-row flex-wrap flex-grow pl-1", children: [
              /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("span", { className: "w-full flex flex-row flex-wrap", children: [
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { className: "font-semibold text-white", children: "\xA1Error!" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                  "button",
                  {
                    "aria-label": "Close",
                    type: "button",
                    className: "ml-auto p-0 bg-transparent focus:outline-none outline-none",
                    "data-id": id,
                    onClick: onDelete,
                    children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(ToastCloseIcon_default, { className: "w-4 h-4" })
                  }
                )
              ] }),
              typeof children === "string" ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { className: "text-sm", children }) : children
            ] })
          ] })
        })
      );
    case "warning":
      return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
        "div",
        __spreadProps(__spreadValues({
          className: "max-w-xs mb-3 bg-primary-500 rounded text-white w-full mx-auto px-4 py-2 shadow-md",
          role: "alert",
          style: { zIndex: 200 }
        }, rest), {
          children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "w-full flex flex-row flex-wrap", children: [
            /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "w-6 h-6 flex m-auto", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
              "svg",
              {
                className: "w-6 h-6 text-white m-auto",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "flex flex-row flex-wrap flex-grow pl-1", children: [
              /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("span", { className: "w-full flex flex-row flex-wrap", children: [
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { className: "font-semibold text-white", children: "\xA1Cuidado!" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                  "button",
                  {
                    "aria-label": "Close",
                    type: "button",
                    className: "ml-auto p-0 bg-transparent focus:outline-none outline-none",
                    "data-id": id,
                    onClick: onDelete,
                    children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                      "svg",
                      {
                        fill: "currentColor",
                        className: "w-4 h-4",
                        viewBox: "0 0 20 20",
                        children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                          "path",
                          {
                            fillRule: "evenodd",
                            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                            clipRule: "evenodd"
                          }
                        )
                      }
                    )
                  }
                )
              ] }),
              typeof children === "string" ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { className: "text-sm", children }) : children
            ] })
          ] })
        })
      );
    case "info":
      return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
        "div",
        __spreadProps(__spreadValues({
          className: "max-w-xs mb-3 bg-primary-300 rounded text-white w-full mx-auto px-4 py-2",
          role: "alert",
          style: { zIndex: 200 }
        }, rest), {
          children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "w-full flex flex-row flex-wrap", children: [
            /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "w-6 h-6 flex m-auto", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
              "svg",
              {
                className: "w-6 h-6 text-white m-auto",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "flex flex-row flex-wrap flex-grow pl-1", children: [
              /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("span", { className: "w-full flex flex-row flex-wrap", children: [
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { className: "font-semibold text-white", children: "\xA1Informaci\xF3n!" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                  "button",
                  {
                    "aria-label": "Close",
                    type: "button",
                    className: "ml-auto p-0 bg-transparent focus:outline-none outline-none",
                    "data-id": id,
                    onClick: onDelete,
                    children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                      "svg",
                      {
                        fill: "currentColor",
                        className: "w-4 h-4",
                        viewBox: "0 0 20 20",
                        children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
                          "path",
                          {
                            fillRule: "evenodd",
                            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                            clipRule: "evenodd"
                          }
                        )
                      }
                    )
                  }
                )
              ] }),
              typeof children === "string" ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { className: "text-sm", children }) : children
            ] })
          ] })
        })
      );
    default:
      return null;
  }
}

// src/icons/EditIcon.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
function EditIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 19 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
          "mask",
          {
            id: "mask0_248_20144",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "15",
            height: "15",
            children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3944 4.4571C16.7032 4.76585 16.7032 5.2646 16.3944 5.57335L14.9457 7.0221L11.9769 4.05335L13.4257 2.6046C13.5736 2.45636 13.7744 2.37305 13.9838 2.37305C14.1932 2.37305 14.394 2.45636 14.5419 2.6046L16.3944 4.4571ZM2.37402 16.2292V13.8225C2.37402 13.7117 2.41361 13.6167 2.49277 13.5375L11.1299 4.90043L14.0986 7.86918L5.45361 16.5063C5.38236 16.5854 5.27944 16.625 5.17652 16.625H2.76986C2.54819 16.625 2.37402 16.4508 2.37402 16.2292Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("g", { mask: "url(#mask0_248_20144)", children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("rect", { width: "19", height: "19", fill: "#2EA89D" }) })
      ]
    })
  );
}
var EditIcon_default = EditIcon;

// src/icons/TrashIcon.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
function TrashIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
          "mask",
          {
            id: "mask0_588_2277",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "4",
            y: "3",
            width: "12",
            height: "15",
            children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.9165 3.83333H14.9998C15.4582 3.83333 15.8332 4.20833 15.8332 4.66667C15.8332 5.125 15.4582 5.5 14.9998 5.5H4.99984C4.5415 5.5 4.1665 5.125 4.1665 4.66667C4.1665 4.20833 4.5415 3.83333 4.99984 3.83333H7.08317L7.67484 3.24167C7.82484 3.09167 8.0415 3 8.25817 3H11.7415C11.9582 3 12.1748 3.09167 12.3248 3.24167L12.9165 3.83333ZM6.6665 18C5.74984 18 4.99984 17.25 4.99984 16.3333V8C4.99984 7.08333 5.74984 6.33333 6.6665 6.33333H13.3332C14.2498 6.33333 14.9998 7.08333 14.9998 8V16.3333C14.9998 17.25 14.2498 18 13.3332 18H6.6665Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("g", { mask: "url(#mask0_588_2277)", children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("rect", { y: "0.5", width: "20", height: "20", fill: "currentColor" }) })
      ]
    })
  );
}
var TrashIcon_default = TrashIcon;

// src/icons/LogoutIcon.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
function LogoutIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 18 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      className,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.74984 1.66667C2.51972 1.66667 2.33317 1.85321 2.33317 2.08333V12.9167C2.33317 13.1468 2.51972 13.3333 2.74984 13.3333H8.58317C8.81329 13.3333 8.99984 13.5199 8.99984 13.75V14.5833C8.99984 14.8135 8.81329 15 8.58317 15H2.33317C1.4165 15 0.666504 14.25 0.666504 13.3333V1.66667C0.666504 0.75 1.4165 0 2.33317 0H8.58317C8.81329 0 8.99984 0.186548 8.99984 0.416667V1.25C8.99984 1.48012 8.81329 1.66667 8.58317 1.66667H2.74984Z",
            fill: "CurrentColor"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
          "path",
          {
            d: "M12.8719 3.62796L12.2856 4.21427C12.1231 4.37677 12.1228 4.64015 12.285 4.80296L14.1415 6.66667H6.08317C5.85305 6.66667 5.6665 6.85321 5.6665 7.08333V7.91667C5.6665 8.14678 5.85305 8.33333 6.08317 8.33333H14.1415L12.2851 10.1897C12.1228 10.3521 12.1223 10.6151 12.2841 10.778L12.8719 11.37C13.0344 11.5337 13.2991 11.5341 13.4622 11.371L17.0385 7.79463C17.2013 7.63191 17.2013 7.36809 17.0385 7.20537L13.4611 3.62796C13.2984 3.46524 13.0346 3.46524 12.8719 3.62796Z",
            fill: "CurrentColor"
          }
        )
      ]
    })
  );
}
var LogoutIcon_default = LogoutIcon;

// src/icons/ExitIcon.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
function ExitIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      className: `h-4 w-4 ${className}`,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor"
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("path", { d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" })
    })
  );
}
var ExitIcon_default = ExitIcon;

// src/icons/MenuIcon.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
function MenuIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      className: `h-4 w-4 ${className}`,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor"
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("path", { d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" })
    })
  );
}
var MenuIcon_default = MenuIcon;

// src/icons/ArrowIcon.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
function ArrowIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 16 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        "path",
        {
          d: "M0.68 2.82L9.84 12L0.68 21.18L3.5 24L15.5 12L3.5 0L0.68 2.82Z",
          fill: "#772E92"
        }
      )
    })
  );
}
var ArrowIcon_default = ArrowIcon;

// src/icons/StarIcon.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var StarIcon = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      "aria-hidden": "true",
      className,
      fill: "currentColor",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })
    })
  );
};
var StarIcon_default = StarIcon;

// src/icons/CalendarIcon.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
function CalendarIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
          "mask",
          {
            id: "mask0_185_17272",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "1",
            width: "20",
            height: "22",
            children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19 3H20C21.1 3 22 3.9 22 5V21C22 22.1 21.1 23 20 23H4C2.9 23 2 22.1 2 21V5C2 3.9 2.9 3 4 3H5V2C5 1.45 5.45 1 6 1C6.55 1 7 1.45 7 2V3H17V2C17 1.45 17.45 1 18 1C18.55 1 19 1.45 19 2V3ZM5 21H19C19.55 21 20 20.55 20 20V8H4V20C4 20.55 4.45 21 5 21Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("g", { mask: "url(#mask0_185_17272)", children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("rect", { width: "24", height: "24", fill: "white" }) })
      ]
    })
  );
}
var CalendarIcon_default = CalendarIcon;

// src/icons/PhotoIcon.tsx
var import_jsx_runtime13 = require("react/jsx-runtime");
function PhotoIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 102 102",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "path",
          {
            d: "M15.2996 10.1992C12.5944 10.1992 9.99999 11.2739 8.08712 13.1867C6.17425 15.0996 5.09961 17.694 5.09961 20.3992V81.5992C5.09961 84.3044 6.17425 86.8988 8.08712 88.8117C9.99999 90.7246 12.5944 91.7992 15.2996 91.7992H86.6996C89.4048 91.7992 91.9992 90.7246 93.9121 88.8117C95.825 86.8988 96.8996 84.3044 96.8996 81.5992V20.3992C96.8996 17.694 95.825 15.0996 93.9121 13.1867C91.9992 11.2739 89.4048 10.1992 86.6996 10.1992H15.2996ZM15.2996 86.6992C13.947 86.6992 12.6498 86.1619 11.6934 85.2055C10.7369 84.249 10.1996 82.9518 10.1996 81.5992V20.3992C10.1996 19.0466 10.7369 17.7494 11.6934 16.793C12.6498 15.8365 13.947 15.2992 15.2996 15.2992H86.6996C88.0522 15.2992 89.3494 15.8365 90.3059 16.793C91.2623 17.7494 91.7996 19.0466 91.7996 20.3992V81.5992C91.7996 82.9518 91.2623 84.249 90.3059 85.2055C89.3494 86.1619 88.0522 86.6992 86.6996 86.6992H15.2996Z",
            fill: "#606060"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "path",
          {
            d: "M86.6998 20.4004H15.2998V71.4004H86.6998V20.4004ZM25.4998 61.2004L38.2498 45.9004L48.4498 56.1004L61.1998 40.8004L76.4998 61.2004H25.4998ZM20.3998 76.5004H81.5998V81.6004H20.3998V76.5004Z",
            fill: "#2EA89D"
          }
        )
      ]
    })
  );
}
var PhotoIcon_default = PhotoIcon;

// src/icons/UserIcon.tsx
var import_jsx_runtime14 = require("react/jsx-runtime");
function UserIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
          "mask",
          {
            id: "mask0_180_16963",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "3",
            y: "3",
            width: "14",
            height: "14",
            children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.333 6.66732C13.333 8.50898 11.8413 10.0007 9.99967 10.0007C8.15801 10.0007 6.66634 8.50898 6.66634 6.66732C6.66634 4.82565 8.15801 3.33398 9.99967 3.33398C11.8413 3.33398 13.333 4.82565 13.333 6.66732ZM3.33301 15.0007C3.33301 12.784 7.77467 11.6673 9.99967 11.6673C12.2247 11.6673 16.6663 12.784 16.6663 15.0007V15.834C16.6663 16.2923 16.2913 16.6673 15.833 16.6673H4.16634C3.70801 16.6673 3.33301 16.2923 3.33301 15.834V15.0007Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("g", { mask: "url(#mask0_180_16963)", children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("rect", { width: "20", height: "20", fill: "currentColor" }) })
      ]
    })
  );
}
var UserIcon_default = UserIcon;

// src/icons/LockIcon.tsx
var import_jsx_runtime15 = require("react/jsx-runtime");
function LockIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
        }
      )
    })
  );
}
var LockIcon_default = LockIcon;

// src/icons/EyeIcon.tsx
var import_jsx_runtime16 = require("react/jsx-runtime");
function EyeIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
          "path",
          {
            d: "M17.7141 9.13435C18.1091 9.65102 18.1091 10.3485 17.7141 10.8643C16.4699 12.4885 13.4849 15.8327 9.99993 15.8327C6.51493 15.8327 3.52993 12.4885 2.28576 10.8643C2.09358 10.617 1.98926 10.3126 1.98926 9.99935C1.98926 9.68608 2.09358 9.38174 2.28576 9.13435C3.52993 7.51018 6.51493 4.16602 9.99993 4.16602C13.4849 4.16602 16.4699 7.51018 17.7141 9.13435V9.13435Z",
            stroke: "#606060",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
          "path",
          {
            d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
            stroke: "#606060",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    })
  );
}
var EyeIcon_default = EyeIcon;

// src/icons/AvilaIcon.tsx
var import_jsx_runtime17 = require("react/jsx-runtime");
function AvilaIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 29 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.4086 3.27066C20.2288 3.3156 20.0991 3.37892 19.9045 3.51658C19.5519 3.76615 19.585 3.70506 18.3025 6.46982C17.6691 7.83532 17.1448 8.9566 17.1373 8.96165C17.1298 8.96671 16.7671 8.1994 16.3312 7.25648C15.5355 5.53531 15.4358 5.33411 15.2988 5.17391C14.6625 4.42914 13.426 4.51121 12.9222 5.33158C12.8754 5.40792 12.4021 6.41022 11.8705 7.55896L10.904 9.64749L10.2311 8.19471C9.45038 6.50941 9.3527 6.35069 8.976 6.15656L8.88754 6.11095V5.39877C8.88754 4.77306 8.88299 4.68474 8.84995 4.67105C8.82923 4.66241 8.67943 4.65542 8.51703 4.65542H8.22171V5.31082V5.96629H8.11851C7.71765 5.96629 7.19226 6.2989 6.95489 6.7031C6.87745 6.83503 2.91895 15.3896 2.91895 15.4251C2.91895 15.4419 7.06731 15.4506 15.1296 15.4506C23.2389 15.4506 27.3403 15.442 27.3403 15.425C27.3403 15.3816 22.0939 4.05523 22.0161 3.93067C21.6909 3.40995 20.995 3.12422 20.4086 3.27066Z",
          fill: "#A6A6A6"
        }
      )
    })
  );
}
var AvilaIcon_default = AvilaIcon;

// src/icons/MailIcon.tsx
var import_jsx_runtime18 = require("react/jsx-runtime");
function MailIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
          "mask",
          {
            id: "mask0_366_21192",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "1",
            y: "3",
            width: "18",
            height: "14",
            children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.33366 3.33398H16.667C17.5837 3.33398 18.3337 4.08398 18.3337 5.00065V15.0007C18.3337 15.9173 17.5837 16.6673 16.667 16.6673H3.33366C2.41699 16.6673 1.66699 15.9173 1.66699 15.0007L1.67533 5.00065C1.67533 4.08398 2.41699 3.33398 3.33366 3.33398ZM10.442 10.559L16.3337 6.87565C16.542 6.74232 16.667 6.51732 16.667 6.27565C16.667 5.71732 16.0587 5.38398 15.5837 5.67565L10.0003 9.16732L4.41699 5.67565C3.94199 5.38398 3.33366 5.71732 3.33366 6.27565C3.33366 6.51732 3.45866 6.74232 3.66699 6.87565L9.55866 10.559C9.82533 10.7257 10.1753 10.7257 10.442 10.559Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime18.jsx)("g", { mask: "url(#mask0_366_21192)", children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)("rect", { width: "20", height: "20", fill: "#858C94" }) })
      ]
    })
  );
}
var MailIcon_default = MailIcon;

// src/icons/LocationIcon.tsx
var import_jsx_runtime19 = require("react/jsx-runtime");
function LocationIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
          }
        )
      ]
    })
  );
}
var LocationIcon_default = LocationIcon;

// src/icons/UpdateIcon.tsx
var import_jsx_runtime20 = require("react/jsx-runtime");
function UpdateIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 19 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
          "mask",
          {
            id: "mask0_1017_1725",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "15",
            height: "15",
            children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2496 3.65707V7.62457C16.2496 7.83457 16.0846 7.99957 15.8746 7.99957H11.9071C11.5696 7.99957 11.4046 7.59457 11.6446 7.35457L13.2121 5.78707C12.2596 4.84207 10.9471 4.24957 9.49958 4.24957C6.58208 4.24957 4.20458 6.64957 4.24958 9.57457C4.29458 12.3646 6.64208 14.7121 9.42458 14.7496C12.1321 14.7871 14.3896 12.7621 14.7121 10.1446C14.7571 9.77707 15.0721 9.49957 15.4471 9.49957C15.8971 9.49957 16.2496 9.88957 16.1971 10.3396C15.7846 13.6696 12.9421 16.2496 9.49958 16.2496C5.51708 16.2496 2.34458 12.7996 2.79458 8.73457C3.13958 5.59207 5.72708 3.06457 8.86958 2.77957C10.9846 2.59207 12.9196 3.37207 14.2771 4.72957L15.6121 3.39457C15.8446 3.15457 16.2496 3.31957 16.2496 3.65707ZM8.74958 9.82207V7.06207C8.74958 6.75457 9.00458 6.49957 9.31208 6.49957C9.61958 6.49957 9.87458 6.75457 9.88208 7.05457V9.60457L12.0346 10.8871C12.3046 11.0446 12.3871 11.3896 12.2296 11.6596C12.0721 11.9221 11.7271 12.0121 11.4571 11.8546L9.11708 10.4671C8.89208 10.3321 8.74958 10.0846 8.74958 9.82207Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("g", { mask: "url(#mask0_1017_1725)", children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("rect", { x: "0.5", y: "0.5", width: "18", height: "18", fill: "white" }) })
      ]
    })
  );
}
var UpdateIcon_default = UpdateIcon;

// src/icons/ToastSuccessIcon.tsx
var import_jsx_runtime21 = require("react/jsx-runtime");
var ToastSuccessIcon2 = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        }
      )
    })
  );
};
var ToastSuccessIcon_default2 = ToastSuccessIcon2;

// src/icons/ToastErrorIcon.tsx
var import_jsx_runtime22 = require("react/jsx-runtime");
function ToastErrorIcon2(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
        }
      )
    })
  );
}
var ToastErrorIcon_default2 = ToastErrorIcon2;

// src/icons/ToastCloseIcon.tsx
var import_jsx_runtime23 = require("react/jsx-runtime");
function ToastCloseIcon2(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "currentColor",
      viewBox: "0 0 20 20",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
        "path",
        {
          fillRule: "evenodd",
          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
          clipRule: "evenodd"
        }
      )
    })
  );
}
var ToastCloseIcon_default2 = ToastCloseIcon2;

// src/icons/SpinnerIcon.tsx
var import_jsx_runtime24 = require("react/jsx-runtime");
function SpinnerIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      "aria-hidden": "true",
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    })
  );
}
var SpinnerIcon_default = SpinnerIcon;

// src/icons/CheckEmptyIcon.tsx
var import_jsx_runtime25 = require("react/jsx-runtime");
function CheckEmptyIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
        "rect",
        {
          x: "0.2",
          y: "0.2",
          width: "15.6",
          height: "15.6",
          rx: "7.8",
          stroke: "#929292",
          strokeWidth: "0.4"
        }
      )
    })
  );
}
var CheckEmptyIcon_default = CheckEmptyIcon;

// src/icons/CheckFullIcon.tsx
var import_jsx_runtime26 = require("react/jsx-runtime");
function CheckFullIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      className,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("rect", { width: "16", height: "16", rx: "8", fill: "#3ABCB0" }),
        /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
          "path",
          {
            d: "M4.5 8.5L6.5 10.5L11.5 5.5",
            stroke: "#FEFEFE",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    })
  );
}
var CheckFullIcon_default = CheckFullIcon;

// src/icons/UploadIcon.tsx
var import_jsx_runtime27 = require("react/jsx-runtime");
function UploadIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
          "mask",
          {
            id: "mask0_118_7700",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "4",
            y: "3",
            width: "12",
            height: "14",
            children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.6667 13.5802H8.33341C7.87508 13.5802 7.50008 13.2052 7.50008 12.7468V8.58016H6.17508C5.43341 8.58016 5.06675 7.68016 5.59175 7.15516L9.41675 3.33016C9.57244 3.17412 9.78382 3.08643 10.0042 3.08643C10.2247 3.08643 10.4361 3.17412 10.5917 3.33016L14.4167 7.15516C14.9417 7.68016 14.5667 8.58016 13.8251 8.58016H12.5001V12.7468C12.5001 13.2052 12.1251 13.5802 11.6667 13.5802ZM15.0001 15.2468H5.00008C4.54175 15.2468 4.16675 15.6218 4.16675 16.0802C4.16675 16.5385 4.54175 16.9135 5.00008 16.9135H15.0001C15.4584 16.9135 15.8334 16.5385 15.8334 16.0802C15.8334 15.6218 15.4584 15.2468 15.0001 15.2468Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("g", { mask: "url(#mask0_118_7700)", children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("rect", { width: "20", height: "20", fill: "#606060" }) })
      ]
    })
  );
}
var UploadIcon_default = UploadIcon;

// src/icons/CloseIcon.tsx
var import_jsx_runtime28 = require("react/jsx-runtime");
function CloseIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
        "path",
        {
          id: "Round",
          d: "M18.2997 5.70996C18.1129 5.5227 17.8592 5.41747 17.5947 5.41747C17.3302 5.41747 17.0766 5.5227 16.8897 5.70996L11.9997 10.59L7.10973 5.69996C6.9229 5.5127 6.66924 5.40747 6.40473 5.40747C6.14021 5.40747 5.88656 5.5127 5.69973 5.69996C5.30973 6.08996 5.30973 6.71996 5.69973 7.10996L10.5897 12L5.69973 16.89C5.30973 17.28 5.30973 17.91 5.69973 18.3C6.08973 18.69 6.71973 18.69 7.10973 18.3L11.9997 13.41L16.8897 18.3C17.2797 18.69 17.9097 18.69 18.2997 18.3C18.6897 17.91 18.6897 17.28 18.2997 16.89L13.4097 12L18.2997 7.10996C18.6797 6.72996 18.6797 6.08996 18.2997 5.70996Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var CloseIcon_default = CloseIcon;

// src/icons/PageIcon.tsx
var import_jsx_runtime29 = require("react/jsx-runtime");
function PageIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      version: "1",
      viewBox: "0 0 25 25",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
          "rect",
          {
            width: "18.263",
            height: "23.263",
            x: "3.369",
            y: "0.869",
            fill: "#fff",
            stroke: "#000",
            strokeWidth: "1.737",
            rx: "1",
            ry: "1"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
          "path",
          {
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: "1.189",
            d: "M7.402 6.5h10.195"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
          "path",
          {
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: "1.189",
            d: "M7.402 10.5h10.195"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
          "path",
          {
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: "1.189",
            d: "M7.402 14.5h10.195"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
          "path",
          {
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: "1.189",
            d: "M7.402 18.5h10.195"
          }
        )
      ]
    })
  );
}
var PageIcon_default = PageIcon;

// src/icons/HomeIcon.tsx
var import_jsx_runtime30 = require("react/jsx-runtime");
function HomeIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
        "path",
        {
          d: "M8.33148 16.1062V11.9396H11.6648V16.1062C11.6648 16.5646 12.0398 16.9396 12.4981 16.9396H14.9981C15.4565 16.9396 15.8315 16.5646 15.8315 16.1062V10.2729H17.2481C17.6315 10.2729 17.8148 9.79791 17.5231 9.54791L10.5565 3.27291C10.2398 2.98958 9.75648 2.98958 9.43982 3.27291L2.47315 9.54791C2.18982 9.79791 2.36482 10.2729 2.74815 10.2729H4.16482V16.1062C4.16482 16.5646 4.53982 16.9396 4.99815 16.9396H7.49815C7.95648 16.9396 8.33148 16.5646 8.33148 16.1062Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var HomeIcon_default = HomeIcon;

// src/icons/InventoryIcon.tsx
var import_jsx_runtime31 = require("react/jsx-runtime");
function InventoryIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        "path",
        {
          d: "M16.6667 1.66669H3.33333C2.5 1.66669 1.66667 2.41669 1.66667 3.33335V5.84169C1.66667 6.44169 2.025 6.95835 2.5 7.25002V16.6667C2.5 17.5834 3.41667 18.3334 4.16667 18.3334H15.8333C16.5833 18.3334 17.5 17.5834 17.5 16.6667V7.25002C17.975 6.95835 18.3333 6.44169 18.3333 5.84169V3.33335C18.3333 2.41669 17.5 1.66669 16.6667 1.66669ZM12.5 11.6667H7.5V10H12.5V11.6667ZM16.6667 5.83335H3.33333V3.33335L16.6667 3.31669V5.83335Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var InventoryIcon_default = InventoryIcon;

// src/icons/VerifiedUserIcon.tsx
var import_jsx_runtime32 = require("react/jsx-runtime");
function VerifiedUserIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.49167 3.64688L9.325 1.05522C9.75 0.863552 10.25 0.863552 10.675 1.05522L16.5083 3.64688C17.1083 3.91355 17.5 4.51355 17.5 5.17189V9.08855C17.5 13.7136 14.3 18.0385 10 19.0886C5.7 18.0385 2.5 13.7136 2.5 9.08855V5.17189C2.5 4.51355 2.89167 3.91355 3.49167 3.64688ZM5.58333 11.3386L7.74167 13.4969C8.06667 13.8219 8.6 13.8219 8.91667 13.4969L14.4083 8.00522C14.7333 7.68022 14.7333 7.15522 14.4083 6.83022C14.0833 6.50522 13.5583 6.50522 13.2333 6.83022L8.33333 11.7302L6.75833 10.1636C6.43333 9.83855 5.90833 9.83855 5.58333 10.1636C5.42729 10.3192 5.3396 10.5306 5.3396 10.7511C5.3396 10.9715 5.42729 11.1829 5.58333 11.3386Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var VerifiedUserIcon_default = VerifiedUserIcon;

// src/icons/SupervisorIcon.tsx
var import_jsx_runtime33 = require("react/jsx-runtime");
function SupervisorIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.99167 6.66667C9.99167 8.05 8.88333 9.16667 7.5 9.16667C6.11667 9.16667 5 8.05 5 6.66667C5 5.28334 6.11667 4.16667 7.5 4.16667C8.88333 4.16667 9.99167 5.28334 9.99167 6.66667ZM15.825 7.91667C15.825 9.06667 14.9 10 13.75 10C12.6 10 11.6667 9.06667 11.6667 7.91667C11.6667 6.76667 12.6 5.83334 13.75 5.83334C14.9 5.83334 15.825 6.76667 15.825 7.91667ZM13.75 11.6667C12.225 11.6667 9.16667 12.4333 9.16667 13.9583V15C9.16667 15.4583 9.54167 15.8333 10 15.8333H17.5C17.9583 15.8333 18.3333 15.4583 18.3333 15V13.9583C18.3333 12.4333 15.275 11.6667 13.75 11.6667ZM1.66667 13.75C1.66667 11.8083 5.55833 10.8333 7.5 10.8333C8.05 10.8333 8.75 10.9167 9.475 11.0667C7.775 12.0083 7.5 13.25 7.5 13.9583V15.8333H2.5C2.04167 15.8333 1.66667 15.4583 1.66667 15V13.75Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var SupervisorIcon_default = SupervisorIcon;

// src/icons/FullListIcon.tsx
var import_jsx_runtime34 = require("react/jsx-runtime");
function FullListIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.35 2.49999H15.8333C16.75 2.49999 17.5 3.24999 17.5 4.16666V17.5C17.5 18.4167 16.75 19.1667 15.8333 19.1667H4.16667C3.25 19.1667 2.5 18.4167 2.5 17.5V4.16666C2.5 3.24999 3.25 2.49999 4.16667 2.49999H7.65C8 1.53333 8.91667 0.833328 10 0.833328C11.0833 0.833328 12 1.53333 12.35 2.49999ZM4.16667 16.6667C4.16667 17.125 4.54167 17.5 5 17.5H15C15.4583 17.5 15.8333 17.125 15.8333 16.6667V4.99999C15.8333 4.54166 15.4583 4.16666 15 4.16666H14.1667V4.99999C14.1667 5.91666 13.4167 6.66666 12.5 6.66666H7.5C6.58333 6.66666 5.83333 5.91666 5.83333 4.99999V4.16666H5C4.54167 4.16666 4.16667 4.54166 4.16667 4.99999V16.6667ZM12.6667 11.6667H7.33333C7.33333 11.6667 6.66667 11.6667 6.66667 12.5C6.66667 13.3333 7.33333 13.3333 7.33333 13.3333H12.6667C12.6667 13.3333 13.3333 13.3333 13.3333 12.5C13.3333 11.6667 12.6667 11.6667 12.6667 11.6667ZM6.66667 8.33333H13.3333C13.3333 8.33333 14.1667 8.33333 14.1667 9.16666C14.1667 9.99999 13.3333 9.99999 13.3333 9.99999H6.66667C6.66667 9.99999 5.83333 9.99999 5.83333 9.16666C5.83333 8.33333 6.66667 8.33333 6.66667 8.33333Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var FullListIcon_default = FullListIcon;

// src/icons/SearchIcon.tsx
var import_jsx_runtime35 = require("react/jsx-runtime");
function SearchIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(
          "mask",
          {
            id: "mask0_706_7813",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "16",
            height: "16",
            children: /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.6553 12.0596H13.3137L16.847 15.6096C17.1887 15.9513 17.1887 16.5096 16.847 16.8513C16.5053 17.193 15.947 17.193 15.6053 16.8513L12.0637 13.3096V12.6513L11.8387 12.418C10.672 13.418 9.08034 13.9346 7.38867 13.6513C5.07201 13.2596 3.22201 11.3263 2.93867 8.99298C2.50534 5.46798 5.47201 2.50131 8.99701 2.93464C11.3303 3.21798 13.2637 5.06798 13.6553 7.38464C13.9387 9.07631 13.422 10.668 12.422 11.8346L12.6553 12.0596ZM4.56367 8.30964C4.56367 10.3846 6.23867 12.0596 8.31367 12.0596C10.3887 12.0596 12.0637 10.3846 12.0637 8.30964C12.0637 6.23464 10.3887 4.55964 8.31367 4.55964C6.23867 4.55964 4.56367 6.23464 4.56367 8.30964Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("g", { mask: "url(#mask0_706_7813)", children: /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("rect", { width: "20", height: "20", fill: "currentColor" }) })
      ]
    })
  );
}
var SearchIcon_default = SearchIcon;

// src/icons/CategoryIcon.tsx
var import_jsx_runtime36 = require("react/jsx-runtime");
function CategoryIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.10033 2.46001L4.62033 6.51335C4.34699 6.95335 4.66699 7.52668 5.18699 7.52668H10.1403C10.6603 7.52668 10.9803 6.95335 10.707 6.51335L8.23366 2.46001C7.97366 2.03335 7.36033 2.03335 7.10033 2.46001ZM11.3337 8.86001C10.2619 8.86001 9.27148 9.43181 8.73558 10.36C8.19968 11.2882 8.19968 12.4318 8.73558 13.36C9.27148 14.2882 10.2619 14.86 11.3337 14.86C12.4055 14.86 13.3958 14.2882 13.9317 13.36C14.4676 12.4318 14.4676 11.2882 13.9317 10.36C13.3958 9.43181 12.4055 8.86001 11.3337 8.86001ZM6.33366 14.5267H2.33366C1.96699 14.5267 1.66699 14.2267 1.66699 13.86V9.86001C1.66699 9.49335 1.96699 9.19335 2.33366 9.19335H6.33366C6.70033 9.19335 7.00033 9.49335 7.00033 9.86001V13.86C7.00033 14.2267 6.70033 14.5267 6.33366 14.5267Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var CategoryIcon_default = CategoryIcon;

// src/icons/AddIcon.tsx
var import_jsx_runtime37 = require("react/jsx-runtime");
function AddIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
        "path",
        {
          id: "Round",
          d: "M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var AddIcon_default = AddIcon;

// src/icons/ArrowBackIcon.tsx
var import_jsx_runtime38 = require("react/jsx-runtime");
function ArrowBackIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
          "mask",
          {
            id: "mask0_849_9883",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "12",
            height: "12",
            children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
              "path",
              {
                d: "M12.5273 7.33664H5.08066L8.334 4.08331C8.594 3.82331 8.594 3.39664 8.334 3.13664C8.20944 3.01181 8.04034 2.94165 7.864 2.94165C7.68765 2.94165 7.51855 3.01181 7.394 3.13664L3.00066 7.52997C2.74066 7.78997 2.74066 8.20997 3.00066 8.46997L7.394 12.8633C7.654 13.1233 8.074 13.1233 8.334 12.8633C8.594 12.6033 8.594 12.1833 8.334 11.9233L5.08066 8.66997H12.5273C12.894 8.66997 13.194 8.36997 13.194 8.00331C13.194 7.63664 12.894 7.33664 12.5273 7.33664Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("g", { mask: "url(#mask0_849_9883)", children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("rect", { width: "16", height: "16", fill: "currentColor" }) })
      ]
    })
  );
}
var ArrowBackIcon_default = ArrowBackIcon;

// src/icons/DotIcon.tsx
var import_jsx_runtime39 = require("react/jsx-runtime");
function DotIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 13 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("g", { filter: "url(#filter0_d_1153_1765)", children: /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("circle", { cx: "6.5", cy: "7", r: "2.5", fill: "currentColor" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)(
          "filter",
          {
            id: "filter0_d_1153_1765",
            x: "0",
            y: "0.5",
            width: "13",
            height: "13",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("feOffset", {}),
              /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("feGaussianBlur", { stdDeviation: "2" }),
              /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("feComposite", { in2: "hardAlpha", operator: "out" }),
              /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0.227451 0 0 0 0 0.737255 0 0 0 0 0.690196 0 0 0 0.25 0"
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_1153_1765"
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_1153_1765",
                  result: "shape"
                }
              )
            ]
          }
        ) })
      ]
    })
  );
}
var DotIcon_default = DotIcon;

// src/icons/MoneyIcon.tsx
var import_jsx_runtime40 = require("react/jsx-runtime");
function MoneyIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      className
    }, props), {
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
        "path",
        {
          id: "Round",
          d: "M12.3 10.9C10.03 10.31 9.3 9.7 9.3 8.75C9.3 7.66 10.31 6.9 12 6.9C13.42 6.9 14.13 7.44 14.39 8.3C14.51 8.7 14.84 9 15.26 9H15.56C16.22 9 16.69 8.35 16.46 7.73C16.04 6.55 15.06 5.57 13.5 5.19V4.5C13.5 3.67 12.83 3 12 3C11.17 3 10.5 3.67 10.5 4.5V5.16C8.56 5.58 7 6.84 7 8.77C7 11.08 8.91 12.23 11.7 12.9C14.2 13.5 14.7 14.38 14.7 15.31C14.7 16 14.21 17.1 12 17.1C10.35 17.1 9.5 16.51 9.17 15.67C9.02 15.28 8.68 15 8.27 15H7.99C7.32 15 6.85 15.68 7.1 16.3C7.67 17.69 9 18.51 10.5 18.83V19.5C10.5 20.33 11.17 21 12 21C12.83 21 13.5 20.33 13.5 19.5V18.85C15.45 18.48 17 17.35 17 15.3C17 12.46 14.57 11.49 12.3 10.9Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var MoneyIcon_default = MoneyIcon;

// src/icons/CollapsibleArrow.tsx
var import_jsx_runtime41 = require("react/jsx-runtime");
function CollapsibleArrow(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "currentColor",
      viewBox: "0 0 20 20",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
          clipRule: "evenodd"
        }
      )
    })
  );
}
var CollapsibleArrow_default = CollapsibleArrow;

// src/icons/DashboardIcon.tsx
var import_jsx_runtime42 = require("react/jsx-runtime");
function DashboardIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 18 18",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
        "path",
        {
          className,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 10H1C0.45 10 0 9.55 0 9V1C0 0.45 0.45 0 1 0H7C7.55 0 8 0.45 8 1V9C8 9.55 7.55 10 7 10ZM7 18H1C0.45 18 0 17.55 0 17V13C0 12.45 0.45 12 1 12H7C7.55 12 8 12.45 8 13V17C8 17.55 7.55 18 7 18ZM11 18H17C17.55 18 18 17.55 18 17V9C18 8.45 17.55 8 17 8H11C10.45 8 10 8.45 10 9V17C10 17.55 10.45 18 11 18ZM10 5V1C10 0.45 10.45 0 11 0H17C17.55 0 18 0.45 18 1V5C18 5.55 17.55 6 17 6H11C10.45 6 10 5.55 10 5Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var DashboardIcon_default = DashboardIcon;

// src/icons/CompanyIcon.tsx
var import_jsx_runtime43 = require("react/jsx-runtime");
function CompanyIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 18 20",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4.12123V9.29123H16C17.1 9.29123 18 10.1912 18 11.2912V17.2912C18 18.3912 17.1 19.2912 16 19.2912H2C0.9 19.2912 0 18.3912 0 17.2912V7.29123C0 6.19123 0.9 5.29123 2 5.29123H6V4.12123C6 3.59123 6.21 3.08123 6.59 2.70123L8.29 1.00123C8.47683 0.813973 8.73048 0.70874 8.995 0.70874C9.25952 0.70874 9.51317 0.813973 9.7 1.00123L11.41 2.71123C11.79 3.08123 12 3.59123 12 4.12123ZM2 17.2912H4V15.2912H2V17.2912ZM4 13.2912H2V11.2912H4V13.2912ZM2 9.29123H4V7.29123H2V9.29123ZM10 17.2912H8V15.2912H10V17.2912ZM8 13.2912H10V11.2912H8V13.2912ZM10 9.29123H8V7.29123H10V9.29123ZM8 5.29123H10V3.29123H8V5.29123ZM16 17.2912H14V15.2912H16V17.2912ZM14 13.2912H16V11.2912H14V13.2912Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var CompanyIcon_default = CompanyIcon;

// src/icons/AllyIcon.tsx
var import_jsx_runtime44 = require("react/jsx-runtime");
function AllyIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
    "svg",
    {
      viewBox: "0 0 20 20",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.99984 4.16667V5.83333H16.6665C17.5832 5.83333 18.3332 6.58333 18.3332 7.5V15.8333C18.3332 16.75 17.5832 17.5 16.6665 17.5H3.33317C2.4165 17.5 1.6665 16.75 1.6665 15.8333V4.16667C1.6665 3.25 2.4165 2.5 3.33317 2.5H8.33317C9.24984 2.5 9.99984 3.25 9.99984 4.16667ZM3.33317 15.8333H4.99984V14.1667H3.33317V15.8333ZM4.99984 12.5H3.33317V10.8333H4.99984V12.5ZM3.33317 9.16667H4.99984V7.5H3.33317V9.16667ZM4.99984 5.83333H3.33317V4.16667H4.99984V5.83333ZM6.6665 15.8333H8.33317V14.1667H6.6665V15.8333ZM8.33317 12.5H6.6665V10.8333H8.33317V12.5ZM6.6665 9.16667H8.33317V7.5H6.6665V9.16667ZM8.33317 5.83333H6.6665V4.16667H8.33317V5.83333ZM9.99984 15.8333H15.8332C16.2915 15.8333 16.6665 15.4583 16.6665 15V8.33333C16.6665 7.875 16.2915 7.5 15.8332 7.5H9.99984V9.16667H11.6665V10.8333H9.99984V12.5H11.6665V14.1667H9.99984V15.8333ZM14.9998 9.16667H13.3332V10.8333H14.9998V9.16667ZM13.3332 12.5H14.9998V14.1667H13.3332V12.5Z",
          fill: "currentColor"
        }
      )
    }
  );
}
var AllyIcon_default = AllyIcon;

// src/icons/LocalOfferIcon.tsx
var import_jsx_runtime45 = require("react/jsx-runtime");
function LocalOfferIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.342 2.14999L17.842 9.64999C18.142 9.94999 18.3337 10.375 18.3337 10.8333C18.3337 11.2917 18.1503 11.7083 17.842 12.0083L12.0087 17.8417C11.7087 18.15 11.292 18.3333 10.8337 18.3333C10.3753 18.3333 9.95866 18.15 9.65866 17.85L2.15866 10.35C1.85033 10.0417 1.66699 9.62499 1.66699 9.16666V3.33332C1.66699 2.41666 2.41699 1.66666 3.33366 1.66666H9.16699C9.62533 1.66666 10.042 1.84999 10.342 2.14999ZM3.33366 4.58332C3.33366 5.27499 3.89199 5.83332 4.58366 5.83332C5.27533 5.83332 5.83366 5.27499 5.83366 4.58332C5.83366 3.89166 5.27533 3.33332 4.58366 3.33332C3.89199 3.33332 3.33366 3.89166 3.33366 4.58332Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var LocalOfferIcon_default = LocalOfferIcon;

// src/icons/SettingsIcon.tsx
var import_jsx_runtime46 = require("react/jsx-runtime");
function SettingsIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 18 18",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.2518 9.00002C15.2518 9.28335 15.2268 9.55002 15.1935 9.81669L16.9518 11.1917C17.1102 11.3167 17.1518 11.5417 17.0518 11.725L15.3852 14.6084C15.2852 14.7917 15.0685 14.8667 14.8768 14.7917L12.8018 13.9584C12.3685 14.2834 11.9018 14.5667 11.3935 14.775L11.0768 16.9834C11.0518 17.1834 10.8768 17.3334 10.6685 17.3334H7.33515C7.12682 17.3334 6.95182 17.1834 6.92682 16.9834L6.61015 14.775C6.10182 14.5667 5.63515 14.2917 5.20182 13.9584L3.12682 14.7917C2.94349 14.8584 2.71849 14.7917 2.61849 14.6084L0.951819 11.725C0.851819 11.5417 0.893486 11.3167 1.05182 11.1917L2.81015 9.81669C2.77682 9.55002 2.75182 9.27502 2.75182 9.00002C2.75182 8.72502 2.77682 8.45002 2.81015 8.18335L1.05182 6.80835C0.893486 6.68335 0.843486 6.45835 0.951819 6.27502L2.61849 3.39169C2.71849 3.20835 2.93515 3.13335 3.12682 3.20835L5.20182 4.04169C5.63515 3.71669 6.10182 3.43335 6.61015 3.22502L6.92682 1.01669C6.95182 0.816687 7.12682 0.666687 7.33515 0.666687H10.6685C10.8768 0.666687 11.0518 0.816687 11.0768 1.01669L11.3935 3.22502C11.9018 3.43335 12.3685 3.70835 12.8018 4.04169L14.8768 3.20835C15.0602 3.14169 15.2852 3.20835 15.3852 3.39169L17.0518 6.27502C17.1518 6.45835 17.1102 6.68335 16.9518 6.80835L15.1935 8.18335C15.2268 8.45002 15.2518 8.71669 15.2518 9.00002ZM6.08515 9.00002C6.08515 10.6084 7.39349 11.9167 9.00182 11.9167C10.6102 11.9167 11.9185 10.6084 11.9185 9.00002C11.9185 7.39169 10.6102 6.08335 9.00182 6.08335C7.39349 6.08335 6.08515 7.39169 6.08515 9.00002Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var SettingsIcon_default = SettingsIcon;

// src/icons/PlanIcon.tsx
var import_jsx_runtime47 = require("react/jsx-runtime");
function PlanIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 2H17C17.55 2 18 2.45 18 3C18 3.55 17.55 4 17 4H7C6.45 4 6 3.55 6 3C6 2.45 6.45 2 7 2ZM5 8H19C19.55 8 20 7.55 20 7C20 6.45 19.55 6 19 6H5C4.45 6 4 6.45 4 7C4 7.55 4.45 8 5 8ZM22 12V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V12C2 10.9 2.9 10 4 10H20C21.1 10 22 10.9 22 12ZM10 12.73L15.19 15.56C15.54 15.75 15.54 16.25 15.19 16.44L10 19.26V12.73Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var PlanIcon_default = PlanIcon;

// src/icons/InfoIcon.tsx
var import_jsx_runtime48 = require("react/jsx-runtime");
function InfoIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      className
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      children: /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
        }
      )
    })
  );
}
var InfoIcon_default = InfoIcon;

// src/icons/SaleIcon.tsx
var import_jsx_runtime49 = require("react/jsx-runtime");
function SaleIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 6h.008v.008H6V6z"
          }
        )
      ]
    })
  );
}
var SaleIcon_default = SaleIcon;

// src/icons/DollarIcon.tsx
var import_jsx_runtime50 = require("react/jsx-runtime");
function DollarIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
        "path",
        {
          id: "Round",
          d: "M12.3 10.9C10.03 10.31 9.3 9.7 9.3 8.75C9.3 7.66 10.31 6.9 12 6.9C13.42 6.9 14.13 7.44 14.39 8.3C14.51 8.7 14.84 9 15.26 9H15.56C16.22 9 16.69 8.35 16.46 7.73C16.04 6.55 15.06 5.57 13.5 5.19V4.5C13.5 3.67 12.83 3 12 3C11.17 3 10.5 3.67 10.5 4.5V5.16C8.56 5.58 7 6.84 7 8.77C7 11.08 8.91 12.23 11.7 12.9C14.2 13.5 14.7 14.38 14.7 15.31C14.7 16 14.21 17.1 12 17.1C10.35 17.1 9.5 16.51 9.17 15.67C9.02 15.28 8.68 15 8.27 15H7.99C7.32 15 6.85 15.68 7.1 16.3C7.67 17.69 9 18.51 10.5 18.83V19.5C10.5 20.33 11.17 21 12 21C12.83 21 13.5 20.33 13.5 19.5V18.85C15.45 18.48 17 17.35 17 15.3C17 12.46 14.57 11.49 12.3 10.9Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var DollarIcon_default = DollarIcon;

// src/icons/BankIcon.tsx
var import_jsx_runtime51 = require("react/jsx-runtime");
function BankIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.17 6.02116L11.07 1.86116C11.65 1.55116 12.35 1.55116 12.93 1.86116L20.83 6.02116C21.24 6.23116 21.5 6.66116 21.5 7.12116C21.5 7.81116 20.94 8.37116 20.26 8.37116H3.75C3.06 8.37116 2.5 7.81116 2.5 7.12116C2.5 6.66116 2.76 6.23116 3.17 6.02116ZM4.5 11.8712V15.8712C4.5 16.7012 5.17 17.3712 6 17.3712C6.83 17.3712 7.5 16.7012 7.5 15.8712V11.8712C7.5 11.0412 6.83 10.3712 6 10.3712C5.17 10.3712 4.5 11.0412 4.5 11.8712ZM10.5 11.8712V15.8712C10.5 16.7012 11.17 17.3712 12 17.3712C12.83 17.3712 13.5 16.7012 13.5 15.8712V11.8712C13.5 11.0412 12.83 10.3712 12 10.3712C11.17 10.3712 10.5 11.0412 10.5 11.8712ZM21.5 20.8712C21.5 21.7012 20.83 22.3712 20 22.3712H4C3.17 22.3712 2.5 21.7012 2.5 20.8712C2.5 20.0412 3.17 19.3712 4 19.3712H20C20.83 19.3712 21.5 20.0412 21.5 20.8712ZM16.5 11.8712V15.8712C16.5 16.7012 17.17 17.3712 18 17.3712C18.83 17.3712 19.5 16.7012 19.5 15.8712V11.8712C19.5 11.0412 18.83 10.3712 18 10.3712C17.17 10.3712 16.5 11.0412 16.5 11.8712Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var BankIcon_default = BankIcon;

// src/icons/CardIcon.tsx
var import_jsx_runtime52 = require("react/jsx-runtime");
function CardIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM19 18H5C4.45 18 4 17.55 4 17V12H20V17C20 17.55 19.55 18 19 18ZM4 8H20V6H4V8Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var CardIcon_default = CardIcon;

// src/icons/ShoppingCarIcon.tsx
var import_jsx_runtime53 = require("react/jsx-runtime");
function ShoppingCarIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.66364 2.49996C1.66364 2.95829 2.03864 3.33329 2.49697 3.33329H3.3303L6.3303 9.65829L5.2053 11.6916C4.59697 12.8083 5.39697 14.1666 6.66364 14.1666H15.8303C16.2886 14.1666 16.6636 13.7916 16.6636 13.3333C16.6636 12.875 16.2886 12.5 15.8303 12.5H6.66364L7.5803 10.8333H13.7886C14.4136 10.8333 14.9636 10.4916 15.247 9.97496L18.2303 4.56663C18.5386 4.01663 18.1386 3.33329 17.5053 3.33329H5.17197L4.61364 2.14163C4.4803 1.84996 4.1803 1.66663 3.86364 1.66663H2.49697C2.03864 1.66663 1.66364 2.04163 1.66364 2.49996ZM6.66364 15C5.74697 15 5.0053 15.75 5.0053 16.6666C5.0053 17.5833 5.74697 18.3333 6.66364 18.3333C7.5803 18.3333 8.3303 17.5833 8.3303 16.6666C8.3303 15.75 7.5803 15 6.66364 15ZM13.3386 16.6666C13.3386 15.75 14.0803 15 14.997 15C15.9136 15 16.6636 15.75 16.6636 16.6666C16.6636 17.5833 15.9136 18.3333 14.997 18.3333C14.0803 18.3333 13.3386 17.5833 13.3386 16.6666Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var ShoppingCarIcon_default = ShoppingCarIcon;

// src/icons/PencilIcon.tsx
var import_jsx_runtime54 = require("react/jsx-runtime");
function PencilIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
        }
      )
    })
  );
}
var PencilIcon_default = PencilIcon;

// src/icons/PhoneIcon.tsx
var import_jsx_runtime55 = require("react/jsx-runtime");
function PhoneIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime55.jsxs)("g", { id: "Communication / phonelink ring", children: [
        /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
          "mask",
          {
            id: "mask0_16_3790",
            width: "20",
            height: "22",
            x: "2",
            y: "1",
            maskUnits: "userSpaceOnUse",
            style: { maskType: "alpha" },
            children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("g", { id: "Icon Mask", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
              "path",
              {
                id: "Round",
                fill: "#000",
                fillRule: "evenodd",
                d: "M4.014 1h10c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2h-10c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2m0 19h10V4h-10zm16.63-11.74a.7.7 0 0 0-1.04-.06l-.03.03c-.25.25-.26.65-.05.93 1.26 1.64 1.25 3.87-.02 5.57-.21.28-.19.67.05.92l.05.05c.29.29.76.26 1.03-.05 1.8-2.13 1.8-5.19.01-7.39m-3.27 2.17.06-.06a.687.687 0 0 1 1.1.17c.5.92.5 1.97.01 2.86-.22.4-.77.47-1.09.15l-.08-.08c-.2-.2-.26-.5-.15-.76.21-.49.21-1.03 0-1.52a.69.69 0 0 1 .15-.76",
                clipRule: "evenodd"
              }
            ) })
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("g", { mask: "url(#mask0_16_3790)", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("path", { id: "Color Fill", fill: "#858C94", d: "M0 0h24v24H0z" }) })
      ] })
    })
  );
}
var PhoneIcon_default = PhoneIcon;

// src/icons/SubscriptionIcon.tsx
var import_jsx_runtime56 = require("react/jsx-runtime");
function SubscriptionIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM4 10H20V5C20 4.45 19.55 4 19 4H5C4.45 4 4 4.45 4 5V10Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var SubscriptionIcon_default = SubscriptionIcon;

// src/icons/BlockIcon.tsx
var import_jsx_runtime57 = require("react/jsx-runtime");
function BlockIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
        "path",
        {
          id: "Round",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 7.58 7.58 4 12 4C13.85 4 15.55 4.63 16.9 5.69L5.69 16.9C4.63 15.55 4 13.85 4 12ZM7.1 18.31C8.45 19.37 10.15 20 12 20C16.42 20 20 16.42 20 12C20 10.15 19.37 8.45 18.31 7.1L7.1 18.31Z"
        }
      )
    })
  );
}
var BlockIcon_default = BlockIcon;

// src/icons/RefreshIcon.tsx
var import_jsx_runtime58 = require("react/jsx-runtime");
function RefreshIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          fill: "currentColor",
          clipRule: "evenodd",
          d: "M12 7.7897V5.9997C8.69 5.9997 6 8.6897 6 11.9997C6 12.7897 6.15 13.5597 6.44 14.2497C6.59 14.6097 6.48 15.0197 6.21 15.2897C5.7 15.7997 4.84 15.6197 4.57 14.9497C4.2 14.0397 4 13.0397 4 11.9997C4 7.5797 7.58 3.9997 12 3.9997V2.2097C12 1.7597 12.54 1.5397 12.85 1.8497L15.64 4.6397C15.84 4.8397 15.84 5.1497 15.64 5.3497L12.85 8.1397C12.54 8.4597 12 8.2397 12 7.7897ZM17.56 9.7497C17.41 9.3997 17.52 8.9797 17.79 8.7097C18.3 8.1997 19.16 8.3797 19.43 9.0497C19.8 9.9597 20 10.9597 20 11.9997C20 16.4197 16.42 19.9997 12 19.9997V21.7997C12 22.2397 11.46 22.4597 11.15 22.1497L8.36 19.3597C8.16 19.1597 8.16 18.8497 8.36 18.6497L11.15 15.8597C11.46 15.5397 12 15.7597 12 16.2097V17.9997C15.31 17.9997 18 15.3097 18 11.9997C18 11.2097 17.84 10.4497 17.56 9.7497Z"
        }
      )
    })
  );
}
var RefreshIcon_default = RefreshIcon;

// src/icons/SendIcon.tsx
var import_jsx_runtime59 = require("react/jsx-runtime");
function SendIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
        "path",
        {
          id: "Round",
          d: "M3.67148 20.4L21.1215 12.92C21.9315 12.57 21.9315 11.43 21.1215 11.08L3.67148 3.60002C3.01148 3.31002 2.28148 3.80002 2.28148 4.51002L2.27148 9.12002C2.27148 9.62002 2.64148 10.05 3.14148 10.11L17.2715 12L3.14148 13.88C2.64148 13.95 2.27148 14.38 2.27148 14.88L2.28148 19.49C2.28148 20.2 3.01148 20.69 3.67148 20.4Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var SendIcon_default = SendIcon;

// src/icons/MinusIcon.tsx
var import_jsx_runtime60 = require("react/jsx-runtime");
function MinusIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime60.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M18 12H6" })
    })
  );
}
var MinusIcon_default = MinusIcon;

// src/icons/HeartIcon.tsx
var import_jsx_runtime61 = require("react/jsx-runtime");
function HeartIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
        "path",
        {
          d: "M11.1247 16.9226C10.4914 17.4976 9.51637 17.4976 8.88303 16.9143L8.79137 16.831C4.41637 12.8726 1.55803 10.281 1.66637 7.04764C1.71637 5.63097 2.44137 4.27264 3.61637 3.47264C5.81637 1.97264 8.53303 2.67264 9.9997 4.38931C11.4664 2.67264 14.183 1.96431 16.383 3.47264C17.558 4.27264 18.283 5.63097 18.333 7.04764C18.4497 10.281 15.583 12.8726 11.208 16.8476L11.1247 16.9226Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var HeartIcon_default = HeartIcon;

// src/icons/ThanksIcon.tsx
var import_jsx_runtime62 = require("react/jsx-runtime");
function ThanksIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 368 369",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
          "rect",
          {
            width: "368",
            height: "369",
            rx: "184",
            fill: "#CF9EE0",
            fillOpacity: "0.2"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("rect", { x: "40", y: "40.5", width: "288", height: "288", rx: "144", fill: "#AE5DCC" }),
        /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
          "mask",
          {
            id: "mask0_248_20128",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "118",
            y: "134",
            width: "132",
            height: "101",
            children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
              "path",
              {
                d: "M159.028 215.016L131.991 187.69C130.535 186.215 128.559 185.386 126.498 185.386C124.437 185.386 122.46 186.215 121.005 187.69C117.966 190.761 117.966 195.722 121.005 198.793L153.574 231.711C156.613 234.782 161.521 234.782 164.56 231.711L246.996 148.393C250.035 145.322 250.035 140.361 246.996 137.29C245.54 135.815 243.564 134.986 241.503 134.986C239.442 134.986 237.465 135.815 236.01 137.29L159.028 215.016Z",
                fill: "black"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("g", { mask: "url(#mask0_248_20128)", children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("rect", { x: "90.5", y: "90", width: "187", height: "189", fill: "white" }) })
      ]
    })
  );
}
var ThanksIcon_default = ThanksIcon;

// src/icons/DeleteIcon.tsx
var import_jsx_runtime63 = require("react/jsx-runtime");
function DeleteIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
        "path",
        {
          fillRule: "evenodd",
          d: "M3.75 12a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z",
          clipRule: "evenodd"
        }
      )
    })
  );
}
var DeleteIcon_default = DeleteIcon;

// src/icons/AirBalloonIllustration.tsx
var import_jsx_runtime64 = require("react/jsx-runtime");
function AirBalloonIllustration(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      "data-name": "Layer 1",
      viewBox: "0 0 865.57286 658.54932",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M475.13088,273.95982a1.42065,1.42065,0,0,1-1.4157-1.32118,50.21123,50.21123,0,0,0-49.94074-46.52628c-1.51455,0-3.10558.077-4.72921.22892A1.42019,1.42019,0,0,1,417.68,225.633a59.66227,59.66227,0,0,0-109.10474,12.97625,1.41413,1.41413,0,0,1-1.39713,1.025l-.37773-.01145c-.1965-.00659-.39282-.01352-.59087-.01352a42.07839,42.07839,0,0,0-41.00433,33.223,1.42071,1.42071,0,0,1-1.3902,1.12763H168.63429a1.42073,1.42073,0,0,1,0-2.84145H262.678a44.94513,44.94513,0,0,1,43.48245-34.35058,62.50318,62.50318,0,0,1,113.52733-13.33317c1.39749-.10891,2.76844-.16371,4.08666-.16371a53.062,53.062,0,0,1,52.77525,49.16864,1.42061,1.42061,0,0,1-1.31788,1.5168C475.198,273.95878,475.16435,273.95982,475.13088,273.95982Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M458.227,292.176H225.22826a1.42072,1.42072,0,1,1,0-2.84144H458.227a1.42072,1.42072,0,1,1,0,2.84144Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M282.05722,312.77652H203.9174a1.42073,1.42073,0,1,1,0-2.84145h78.13982a1.42073,1.42073,0,0,1,0,2.84145Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M355.11428,589.21139c0,57.75962-60.55444,85.39729-60.55444,85.39729s-61.17551-27.63767-62.41765-85.39729c-.73011-33.95,27.52824-61.48605,61.486-61.48605A61.486,61.486,0,0,1,355.11428,589.21139Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#e5e5e5"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "147.842 557.299 106.851 557.299 101.882 537.425 152.81 537.425 147.842 557.299",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "108.24833",
            y: "591.28757",
            width: "38.19588",
            height: "19.90489",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M313.96832,732.22835h-38.817v-20.526h38.817Zm-38.19588-.62107h37.57481V712.32344H275.77244Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "135.176 559.643 119.517 559.643 117.72 556.819 136.973 556.819 135.176 559.643",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "107.16146",
            y: "557.29923",
            width: "0.62107",
            height: "30.43249",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "146.91002",
            y: "557.29923",
            width: "0.62107",
            height: "30.43249",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M300.78526,657.81368l-.37922-.49189c17.94222-13.83627,39.33014-37.54008,39.33014-71.89a61.09179,61.09179,0,0,0-37.36337-56.36812l.242-.572a61.71164,61.71164,0,0,1,37.74244,56.94007C340.35725,620.034,318.8378,643.89219,300.78526,657.81368Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M280.91076,657.81383l-.37923-.49189c17.9423-13.83627,39.33037-37.54008,39.33037-71.8902A61.16369,61.16369,0,0,0,282.924,529.24542l.24624-.57012A61.78432,61.78432,0,0,1,320.483,585.43174C320.483,620.03417,298.96344,643.89249,280.91076,657.81383Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M306.34549,657.81368c-18.05254-13.92134-39.572-37.77951-39.572-72.38194a61.78407,61.78407,0,0,1,37.31325-56.7566l.24624.57013a61.16357,61.16357,0,0,0-36.93842,56.18647c0,34.35,21.38791,58.05378,39.33014,71.89Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M286.47128,657.81368c-18.05261-13.92134-39.57206-37.77936-39.57206-72.38194a61.66876,61.66876,0,0,1,37.99459-57.04606l.23943.57316a61.04905,61.04905,0,0,0-37.613,56.4729c0,34.35027,21.388,58.05393,39.33022,71.89Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "126.10413",
            y: "407",
            width: "0.62107",
            height: "130.42495",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "line",
          {
            x1: "108.24833",
            y1: "598.38284",
            x2: "119.63694",
            y2: "586.99424",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "273.10322",
            y: "713.10337",
            width: "16.10597",
            height: "0.621",
            transform: "translate(-589.32461 287.0362) rotate(-45)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "line",
          {
            x1: "108.24833",
            y1: "604.60334",
            x2: "125.17986",
            y2: "586.80011",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "271.64323",
            y: "716.11655",
            width: "24.56889",
            height: "0.62099",
            transform: "translate(-598.12788 307.80663) rotate(-46.44446)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "103.43503",
            y: "586.80011",
            width: "46.58034",
            height: "5.58964",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M317.53948,713.42563H270.33807v-6.21071h47.20141Zm-46.58034-.62107H316.9184V707.836H270.95914Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M472.30444,442.83091c0,38.12387-39.96858,56.36594-39.96858,56.36594s-40.37851-18.24207-41.19838-56.36594c-.4819-22.40846,18.16984-40.58348,40.58348-40.58348A40.58348,40.58348,0,0,1,472.30444,442.83091Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#e5e5e5"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "278.65 380.726 251.594 380.726 248.315 367.608 281.93 367.608 278.65 380.726",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "252.51682",
            y: "403.15993",
            width: "25.21095",
            height: "13.1381",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M445.1463,537.22835H419.52542v-13.548H445.1463Zm-25.21095-.40994h24.801V524.09024h-24.801Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "270.29 382.273 259.954 382.273 258.768 380.409 271.476 380.409 270.29 382.273",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "251.79943",
            y: "380.72614",
            width: "0.40993",
            height: "20.08677",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "278.03522",
            y: "380.72614",
            width: "0.40993",
            height: "20.08677",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M436.44491,488.11141l-.2503-.32466c11.84265-9.13254,25.9596-24.7781,25.9596-47.45058a40.32325,40.32325,0,0,0-24.66145-37.20542l.15973-.37751a40.73238,40.73238,0,0,1,24.91166,37.58293C462.56415,463.17519,448.36037,478.92262,436.44491,488.11141Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M423.32687,488.11151l-.25031-.32466c11.84271-9.13254,25.95976-24.7781,25.95976-47.45068a40.3707,40.3707,0,0,0-24.38062-37.08542l.16253-.37631a40.78035,40.78035,0,0,1,24.628,37.46173C449.44626,463.17529,435.24243,478.92282,423.32687,488.11151Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M440.1149,488.11141c-11.91546-9.18869-26.11924-24.93612-26.11924-47.77524A40.78018,40.78018,0,0,1,438.624,402.87434l.16253.37631a40.37063,40.37063,0,0,0-24.381,37.08552c0,22.67248,14.117,38.318,25.95961,47.45058Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M426.99706,488.11141c-11.91551-9.18869-26.11929-24.936-26.11929-47.77524a40.704,40.704,0,0,1,25.07809-37.65288l.158.3783a40.295,40.295,0,0,0-24.82618,37.27458c0,22.67268,14.117,38.31814,25.95965,47.45058Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "264.30242",
            y: "281.52209",
            width: "0.40993",
            height: "86.08616",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "line",
          {
            x1: "252.51682",
            y1: "407.84313",
            x2: "260.0338",
            y2: "400.32615",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "418.17355",
            y: "524.60503",
            width: "10.63065",
            height: "0.40989",
            transform: "translate(-414.27324 332.4398) rotate(-45)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "line",
          {
            x1: "252.51682",
            y1: "411.94892",
            x2: "263.69236",
            y2: "400.19802",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "417.2099",
            y: "526.59386",
            width: "16.21654",
            height: "0.40988",
            transform: "translate(-416.73868 351.30978) rotate(-46.44446)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "249.33983",
            y: "400.19802",
            width: "30.74506",
            height: "3.68941",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M447.50342,524.81773h-31.155v-4.09934h31.155Zm-30.74506-.40993h30.33513v-3.27948H416.75836Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M812.07517,494.95319a1.0183,1.0183,0,0,0,1.01475-.947,35.99077,35.99077,0,0,1,35.79689-33.34945c1.08561,0,2.226.05519,3.38985.16409a1.018,1.018,0,0,0,.97857-.50769,42.76517,42.76517,0,0,1,78.20491,9.30121,1.01364,1.01364,0,0,0,1.00145.73468l.27075-.00821c.14085-.00472.28157-.00969.42353-.00969a30.16126,30.16126,0,0,1,29.39139,23.81379,1.01834,1.01834,0,0,0,.99648.80827h68.22433a1.01836,1.01836,0,1,0,0-2.03671H964.35872a32.21611,32.21611,0,0,0-31.16767-24.62207,44.8015,44.8015,0,0,0-81.375-9.557c-1.0017-.07807-1.98438-.11735-2.92927-.11735a38.03414,38.03414,0,0,0-37.82863,35.24346,1.01828,1.01828,0,0,0,.94464,1.08723C812.02706,494.95245,812.05117,494.95319,812.07517,494.95319Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M824.19165,508.01034H991.20223a1.01835,1.01835,0,1,0,0-2.03671H824.19165a1.01835,1.01835,0,0,0,0,2.03671Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M950.46794,522.77652h56.00965a1.01836,1.01836,0,0,0,0-2.03671H950.46794a1.01835,1.01835,0,1,0,0,2.03671Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "522.992 647.768 519.639 647.768 518.044 634.839 522.992 634.839 522.992 647.768",
            fill: "#9f616a"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M691.06018,771.743H680.2515v-.13671a4.21189,4.21189,0,0,1,4.20717-4.20711h6.60151Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "566.219 641.416 563.345 643.143 555.319 632.881 559.56 630.333 566.219 641.416",
            fill: "#9f616a"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M726.57374,770.05331l-.07043-.11722a4.212,4.212,0,0,1,1.43949-5.773l5.65874-3.39979,2.23713,3.72341Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M691.07674,765.82538l-.05781-.00027a45.01358,45.01358,0,0,1-4.88046-.2809c-.61767-.061-1.28768-.12724-2.09494-.19346l-.0277-.0052c-.55079-.16368-.56608-5.32925-.33257-23.01079.11962-9.05639.25513-19.32089.09379-25.85785l-.0016-.06422.04853-.04232a24.5749,24.5749,0,0,1,21.62317-5.48959l.05908.01229.0307.05193c3.29451,5.57436,8.26883,13.60381,13.07932,21.369,11.04286,17.82547,14.20119,23.06793,13.855,23.46338l-.04172.03231c-.75406.377-1.3202.66727-1.80156.91413a59.40563,59.40563,0,0,1-5.86341,2.64453l-.08852.03645-.06455-.07076c-11.20473-12.27794-20.52907-25.9931-26.29656-38.67183-.67394,4.32847-1.49195,9.98054-2.35628,15.95249-2.48545,17.17288-4.16525,28.48088-4.84147,29.16938Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M694.09569,717.79784a58.69173,58.69173,0,0,1,19.62556,3.28577,44.67268,44.67268,0,0,0-10.01451-29.12533l-.04927-.05928.02523-.07276c1.76011-5.08572,3.57936-10.34247,5.205-15.57319l-.02463-.08785c-1.14009-4.05317-3.58723-8.14893-7.48106-12.52159a2.39636,2.39636,0,0,0-3.27122-.16568,30.476,30.476,0,0,0-9.82125,24.81008l.00253.0263-.00754.0255c-3.049,10.32965-4.15584,15.63527-5.13238,20.31633-.71234,3.41473-1.32914,6.37154-2.5675,10.59627A63.62216,63.62216,0,0,1,694.09569,717.79784Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "536.719 564.419 526.8 586.013 521.133 580.277 536.719 564.419",
            opacity: "0.1"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("circle", { cx: "532.47798", cy: "533.75944", r: "7.0569", fill: "#9f616a" }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M691.13527,650.49848h11.20551V645.614c-2.45948-.97711-4.86621-1.80809-6.32106,0a4.88448,4.88448,0,0,0-4.88445,4.88445Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M702.96116,644.75206c6.69887,0,8.57389,8.39678,8.57389,13.13382,0,2.64179-1.19474,3.58667-3.07214,3.90638l-.663-3.53611-1.55291,3.68828c-.52736.00263-1.08138-.00758-1.65574-.01824l-.52652-1.08416-1.17412,1.06471c-4.70249.007-8.50318.69249-8.50318-4.02086C694.38741,653.14884,696.03179,644.75206,702.96116,644.75206Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M905.30444,318.72534c0,186-195,275-195,275s-197-89-201-275c-2.35112-109.3271,88.64762-198,198-198S905.30444,209.373,905.30444,318.72534Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#772e92"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "547.274 646.307 543.163 646.307 541.208 630.453 547.274 630.453 547.274 646.307",
            fill: "#ffb7b7"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M540.22741,645.13222h7.92694a0,0,0,0,1,0,0v4.991a0,0,0,0,1,0,0h-12.918a0,0,0,0,1,0,0v0A4.991,4.991,0,0,1,540.22741,645.13222Z",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "562.696 646.307 558.586 646.307 556.63 630.453 562.697 630.453 562.696 646.307",
            fill: "#ffb7b7"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M555.64958,645.13222h7.927a0,0,0,0,1,0,0v4.991a0,0,0,0,1,0,0h-12.918a0,0,0,0,1,0,0v0A4.991,4.991,0,0,1,555.64958,645.13222Z",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M729.40736,719.814a3.60166,3.60166,0,0,1-.69139-5.47924l-2.70642-38.40719,7.7959.75606.21413,37.61221a3.62116,3.62116,0,0,1-4.61222,5.51816Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#ffb7b7"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M714.293,759.04523l-4.52484-.21576a1.50837,1.50837,0,0,1-1.43691-1.49625l-.31578-45.78261a1.50905,1.50905,0,0,1,1.72543-1.50378l18.10216,2.62777a1.49992,1.49992,0,0,1,1.292,1.48184l2.32819,42.42243a1.50886,1.50886,0,0,1-1.50869,1.52015h-4.87812a1.50159,1.50159,0,0,1-1.49035-1.27427s-3.68464-31.82068-4.19057-31.802c-.5087.00949-3.53263,32.69486-3.53263,32.69486a1.51443,1.51443,0,0,1-1.49822,1.3296Q714.32906,759.04719,714.293,759.04523Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M727.77429,688.83291a1.50258,1.50258,0,0,1-.62316-1.14012l-.57124-10.35168a4.15682,4.15682,0,0,1,8.1625-1.31653l2.5093,9.255a1.51039,1.51039,0,0,1-1.06132,1.85092l-7.138,1.93533A1.50293,1.50293,0,0,1,727.77429,688.83291Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("circle", { cx: "553.89292", cy: "535.27109", r: "8.23444", fill: "#ffb7b7" }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M726.93359,662.51115a2.65975,2.65975,0,0,1-4.58922-1.47757,2.70079,2.70079,0,0,1,.0034-.52157c.10335-.99022.67543-1.88923.53839-2.93477a1.539,1.539,0,0,0-.28165-.72045c-1.22414-1.63922-4.0977.73318-5.253-.75076-.7084-.90992.12432-2.34253-.4193-3.35952-.71748-1.34226-2.84264-.68012-4.17534-1.4152-1.48279-.81788-1.3941-3.0929-.418-4.47669a7.04185,7.04185,0,0,1,5.33854-2.71786,14.3202,14.3202,0,0,1,6.03218,1.17727,12.05493,12.05493,0,0,1,5.69972,3.95194,9.64786,9.64786,0,0,1,.97534,8.21456C729.88685,659.14346,728.188,661.17489,726.93359,662.51115Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M729.32568,669.73127q-.21461-.15422-.43757-.30285a10.84928,10.84928,0,0,0-2.54657-1.24859v-2.16367h-6.37v2.00746a11.17082,11.17082,0,0,0-8.101,9.2822L707.533,709.50825a1.50116,1.50116,0,0,0,.312,1.14036,1.48163,1.48163,0,0,0,1.02381.56085,22.7729,22.7729,0,0,1,8.60949,2.94895,12.78206,12.78206,0,0,0,6.27131,1.60069,15.11672,15.11672,0,0,0,5.10476-.90888,1.49748,1.49748,0,0,0,.97829-1.3427c.15618-3.4656,1.06964-21.304,3.7295-32.18507A11.12326,11.12326,0,0,0,729.32568,669.73127Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "609.091 484 477.091 484 461.091 420 625.091 420 609.091 484",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "481.59087",
            y: "593.4507",
            width: "123",
            height: "64.09859",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M772.80444,779.27466h-125V713.176h125Zm-123-2h121V715.176h-121Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "polygon",
          {
            points: "568.304 491.547 517.878 491.547 512.091 482.453 574.091 482.453 568.304 491.547",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("rect", { x: "478.09087", y: "484", width: "2", height: "98", fill: "#3f3d56" }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("rect", { x: "606.09087", y: "484", width: "2", height: "98", fill: "#3f3d56" }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M730.3518,539.64136l-1.22119-1.584C786.90893,493.50122,855.7832,417.16919,855.7832,306.554A196.7304,196.7304,0,0,0,735.46411,125.03491l.77929-1.84179A198.72645,198.72645,0,0,1,857.7832,306.554C857.7832,417.98169,788.48535,494.81079,730.3518,539.64136Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M666.35107,539.64185l-1.22119-1.584C722.90844,493.50171,791.7832,417.16968,791.7832,306.554a196.96192,196.96192,0,0,0-118.949-180.9336l.793-1.83594A198.96056,198.96056,0,0,1,793.7832,306.554C793.7832,417.98218,724.4851,494.81177,666.35107,539.64185Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M748.25707,539.64136C690.12353,494.81128,620.82568,417.98218,620.82568,306.554a198.95968,198.95968,0,0,1,120.15771-182.77l.793,1.83593A196.9616,196.9616,0,0,0,622.82568,306.554c0,110.61523,68.87427,186.94726,126.65259,231.50341Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M684.25732,539.64136C626.12353,494.81128,556.82568,417.98267,556.82568,306.554a198.5883,198.5883,0,0,1,122.3518-183.70215l.771,1.8457A196.59273,196.59273,0,0,0,558.82568,306.554c0,110.61621,68.87451,186.94775,126.65283,231.50341Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("rect", { x: "539.09087", width: "2", height: "420", fill: "#3f3d56" }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "line",
          {
            x1: "481.59087",
            y1: "616.29921",
            x2: "518.26494",
            y2: "579.62514",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "641.2089",
            y: "717.68761",
            width: "51.86514",
            height: "1.99979",
            transform: "translate(-480.00116 561.51361) rotate(-45)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("line", { x1: "481.59087", y1: "636.33071", x2: "536.11449", y2: "579", fill: "#fff" }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "rect",
          {
            x: "636.50738",
            y: "727.39076",
            width: "79.1178",
            height: "1.99973",
            transform: "translate(-484.86538 595.71211) rotate(-46.44446)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("rect", { x: "466.09087", y: "579", width: "150", height: "18", fill: "#fff" }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M784.30444,718.72534h-152v-20h152Zm-150-2h148v-16h-148Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M681.81868,708.09726a2.74948,2.74948,0,0,0,2.47585-3.41248l8.17284-5.35471-4.661-2.01364-7.04648,5.39363a2.7644,2.7644,0,0,0,1.05884,5.3872Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#9f616a"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M689.68278,704.23969l-.10307-.0729c-1.94508-1.4316-4.10444-2.91207-6.19271-4.34382l-.12543-.086.0988-.11562c4.45717-5.21483,8.91914-10.66183,13.235-15.93112l-.00828-.019.04066-.0207.01722-.021.00921.00761.026-.01321-.11762.00907-1.3302-10.43178a6.6868,6.6868,0,0,1,.14305-7.165,5.67453,5.67453,0,0,1,7.38427-1.68608,4.84545,4.84545,0,0,1,2.12772,3.61847,4.37007,4.37007,0,0,1-1.15839,3.57842,150.47526,150.47526,0,0,1,.60806,15.22847l.00021.04766-.02951.03925c-4.601,5.84525-9.65484,11.6594-14.5423,17.28209Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M691.2667,672.1745a3.52839,3.52839,0,0,1,.08022.54988L705.749,681.0329l3.50063-2.01525,3.73189,4.88556-7.48885,5.3376-16.43062-12.96222a3.51887,3.51887,0,1,1,2.20461-4.10409Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#ffb7b7"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M706.26342,680.32639a1.50256,1.50256,0,0,1,.43355-1.22484l7.33-7.33173a4.15681,4.15681,0,0,1,6.42637,5.202l-5.22,8.04373a1.51039,1.51039,0,0,1-2.08685.44426l-6.20383-4.026A1.503,1.503,0,0,1,706.26342,680.32639Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M606.53371,608.95319a1.01829,1.01829,0,0,1-1.01475-.947,35.99077,35.99077,0,0,0-35.7969-33.34945c-1.08561,0-2.226.05519-3.38984.16409a1.018,1.018,0,0,1-.97858-.50769,42.76517,42.76517,0,0,0-78.20491,9.30121,1.01364,1.01364,0,0,1-1.00145.73468l-.27075-.00821c-.14084-.00472-.28156-.00969-.42352-.00969a30.16126,30.16126,0,0,0-29.39139,23.81379,1.01836,1.01836,0,0,1-.99648.80827H386.8408a1.01836,1.01836,0,1,1,0-2.03671h67.40935a32.21612,32.21612,0,0,1,31.16768-24.62207,44.80149,44.80149,0,0,1,81.375-9.557c1.0017-.07807,1.98438-.11735,2.92927-.11735a38.03415,38.03415,0,0,1,37.82864,35.24346,1.01828,1.01828,0,0,1-.94464,1.08723C606.58182,608.95245,606.5577,608.95319,606.53371,608.95319Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M594.41722,622.01034H427.40665a1.01836,1.01836,0,1,1,0-2.03671H594.41722a1.01835,1.01835,0,1,1,0,2.03671Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
          "path",
          {
            d: "M468.14093,636.77652H412.13129a1.01836,1.01836,0,1,1,0-2.03671h56.00964a1.01836,1.01836,0,1,1,0,2.03671Z",
            transform: "translate(-167.21357 -120.72534)",
            fill: "#cbcbcb"
          }
        )
      ]
    })
  );
}
var AirBalloonIllustration_default = AirBalloonIllustration;

// src/icons/EmptyIllustration.tsx
var import_jsx_runtime65 = require("react/jsx-runtime");
function EmptyIllustration(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime65.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      "data-name": "Layer 1",
      width: "647.63626",
      height: "632.17383",
      viewBox: "0 0 647.63626 632.17383",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          "path",
          {
            d: "M687.3279,276.08691H512.81813a15.01828,15.01828,0,0,0-15,15v387.85l-2,.61005-42.81006,13.11a8.00676,8.00676,0,0,1-9.98974-5.31L315.678,271.39691a8.00313,8.00313,0,0,1,5.31006-9.99l65.97022-20.2,191.25-58.54,65.96972-20.2a7.98927,7.98927,0,0,1,9.99024,5.3l32.5498,106.32Z",
            transform: "translate(-276.18187 -133.91309)",
            fill: "#f2f2f2"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          "path",
          {
            d: "M725.408,274.08691l-39.23-128.14a16.99368,16.99368,0,0,0-21.23-11.28l-92.75,28.39L380.95827,221.60693l-92.75,28.4a17.0152,17.0152,0,0,0-11.28028,21.23l134.08008,437.93a17.02661,17.02661,0,0,0,16.26026,12.03,16.78926,16.78926,0,0,0,4.96972-.75l63.58008-19.46,2-.62v-2.09l-2,.61-64.16992,19.65a15.01489,15.01489,0,0,1-18.73-9.95l-134.06983-437.94a14.97935,14.97935,0,0,1,9.94971-18.73l92.75-28.4,191.24024-58.54,92.75-28.4a15.15551,15.15551,0,0,1,4.40966-.66,15.01461,15.01461,0,0,1,14.32032,10.61l39.0498,127.56.62012,2h2.08008Z",
            transform: "translate(-276.18187 -133.91309)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          "path",
          {
            d: "M398.86279,261.73389a9.0157,9.0157,0,0,1-8.61133-6.3667l-12.88037-42.07178a8.99884,8.99884,0,0,1,5.9712-11.24023l175.939-53.86377a9.00867,9.00867,0,0,1,11.24072,5.9707l12.88037,42.07227a9.01029,9.01029,0,0,1-5.9707,11.24072L401.49219,261.33887A8.976,8.976,0,0,1,398.86279,261.73389Z",
            transform: "translate(-276.18187 -133.91309)",
            fill: "#59d1ce"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("circle", { cx: "190.15351", cy: "24.95465", r: "20", fill: "#59d1ce" }),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("circle", { cx: "190.15351", cy: "24.95465", r: "12.66462", fill: "#fff" }),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          "path",
          {
            d: "M878.81836,716.08691h-338a8.50981,8.50981,0,0,1-8.5-8.5v-405a8.50951,8.50951,0,0,1,8.5-8.5h338a8.50982,8.50982,0,0,1,8.5,8.5v405A8.51013,8.51013,0,0,1,878.81836,716.08691Z",
            transform: "translate(-276.18187 -133.91309)",
            fill: "#e6e6e6"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          "path",
          {
            d: "M723.31813,274.08691h-210.5a17.02411,17.02411,0,0,0-17,17v407.8l2-.61v-407.19a15.01828,15.01828,0,0,1,15-15H723.93825Zm183.5,0h-394a17.02411,17.02411,0,0,0-17,17v458a17.0241,17.0241,0,0,0,17,17h394a17.0241,17.0241,0,0,0,17-17v-458A17.02411,17.02411,0,0,0,906.81813,274.08691Zm15,475a15.01828,15.01828,0,0,1-15,15h-394a15.01828,15.01828,0,0,1-15-15v-458a15.01828,15.01828,0,0,1,15-15h394a15.01828,15.01828,0,0,1,15,15Z",
            transform: "translate(-276.18187 -133.91309)",
            fill: "#3f3d56"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          "path",
          {
            d: "M801.81836,318.08691h-184a9.01015,9.01015,0,0,1-9-9v-44a9.01016,9.01016,0,0,1,9-9h184a9.01016,9.01016,0,0,1,9,9v44A9.01015,9.01015,0,0,1,801.81836,318.08691Z",
            transform: "translate(-276.18187 -133.91309)",
            fill: "#59d1ce"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("circle", { cx: "433.63626", cy: "105.17383", r: "20", fill: "#59d1ce" }),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("circle", { cx: "433.63626", cy: "105.17383", r: "12.18187", fill: "#fff" })
      ]
    })
  );
}
var EmptyIllustration_default = EmptyIllustration;

// src/icons/RemoveIcon.tsx
var import_jsx_runtime66 = require("react/jsx-runtime");
function RemoveIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        }
      )
    })
  );
}
var RemoveIcon_default = RemoveIcon;

// src/icons/TimerIcon.tsx
var import_jsx_runtime67 = require("react/jsx-runtime");
function TimerIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
        }
      )
    })
  );
}
var TimerIcon_default = TimerIcon;

// src/icons/TableIcon.tsx
var import_jsx_runtime68 = require("react/jsx-runtime");
function TableIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "none",
      className
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 4C12.55 4 13 4.45 13 5C13 5.55 12.55 6 12 6C11.45 6 11 5.55 11 5C11 4.45 11.45 4 12 4ZM7 14L11.65 18.65C11.84 18.84 12.16 18.84 12.35 18.65L17 14H14V10H10V14H7Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var TableIcon_default = TableIcon;

// src/icons/BookIcon.tsx
var import_jsx_runtime69 = require("react/jsx-runtime");
function BookIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "none",
      className
    }, props), {
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime69.jsxs)("g", { id: "Action / book", children: [
        /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("g", { id: "Icon Mask", children: /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
          "path",
          {
            id: "Round",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 2H18C19.1 2 20 2.9 20 4V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2ZM11 4H6V12L8.5 10.5L11 12V4Z",
            fill: "currentColor"
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("g", { mask: "url(#mask0_16_1231)", children: /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("rect", { id: "Color Fill", width: "24", height: "24", fill: "currentColor" }) })
      ] })
    })
  );
}
var BookIcon_default = BookIcon;

// src/icons/WalletIcon.tsx
var import_jsx_runtime70 = require("react/jsx-runtime");
function WalletIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "none",
      className,
      viewBox: "0 0 20 20"
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.5 16V8C9.5 6.9 10.39 6 11.5 6H20.5V5C20.5 3.9 19.6 3 18.5 3H4.5C3.39 3 2.5 3.9 2.5 5V19C2.5 20.1 3.39 21 4.5 21H18.5C19.6 21 20.5 20.1 20.5 19V18H11.5C10.39 18 9.5 17.1 9.5 16ZM12.5 8C11.95 8 11.5 8.45 11.5 9V15C11.5 15.55 11.95 16 12.5 16H21.5V8H12.5ZM14 12C14 12.83 14.67 13.5 15.5 13.5C16.33 13.5 17 12.83 17 12C17 11.17 16.33 10.5 15.5 10.5C14.67 10.5 14 11.17 14 12Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var WalletIcon_default = WalletIcon;

// src/icons/GoalIcon.tsx
var import_jsx_runtime71 = require("react/jsx-runtime");
function GoalIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      fill: "none",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 9C4.55 9 5 8.55 5 8C5 7.45 4.55 7 4 7C3.45 7 3 7.45 3 8C3 8.55 3.45 9 4 9ZM5 12C5 12.55 4.55 13 4 13C3.45 13 3 12.55 3 12C3 11.45 3.45 11 4 11C4.55 11 5 11.45 5 12ZM5 16C5 16.55 4.55 17 4 17C3.45 17 3 16.55 3 16C3 15.45 3.45 15 4 15C4.55 15 5 15.45 5 16ZM20 13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H20C20.55 11 21 11.45 21 12C21 12.55 20.55 13 20 13ZM8 17H20C20.55 17 21 16.55 21 16C21 15.45 20.55 15 20 15H8C7.45 15 7 15.45 7 16C7 16.55 7.45 17 8 17ZM8 9C7.45 9 7 8.55 7 8C7 7.45 7.45 7 8 7H20C20.55 7 21 7.45 21 8C21 8.55 20.55 9 20 9H8Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var GoalIcon_default = GoalIcon;

// src/icons/UploadImageIcon.tsx
var import_jsx_runtime72 = require("react/jsx-runtime");
function UploadImageIcon(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
        "path",
        {
          id: "Round",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4C15.64 4 18.67 6.59 19.35 10.04C21.95 10.22 24 12.36 24 15C24 17.76 21.76 20 19 20H6C2.69 20 0 17.31 0 14C0 10.91 2.34 8.36 5.35 8.04C6.6 5.64 9.11 4 12 4ZM14 17V13H17L12.36 8.35C12.16 8.15 11.85 8.15 11.65 8.35L7 13H10V17H14Z",
          fill: "currentColor"
        }
      )
    })
  );
}
var UploadImageIcon_default = UploadImageIcon;

// src/icons/LinkedinIcon.tsx
var import_jsx_runtime73 = require("react/jsx-runtime");
function LinkedinIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(
        "path",
        {
          d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z",
          fill: "#E4E4F5"
        }
      )
    })
  );
}
var LinkedinIcon_default = LinkedinIcon;

// src/icons/BagIcon.tsx
var import_jsx_runtime74 = require("react/jsx-runtime");
function BagIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      className
    }, props), {
      children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
        }
      )
    })
  );
}
var BagIcon_default = BagIcon;

// src/icons/WhatsAppIcon.tsx
var import_jsx_runtime75 = require("react/jsx-runtime");
function WhatsAppIcon(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime75.jsxs)(
    "svg",
    __spreadProps(__spreadValues({
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime75.jsxs)("g", { clipPath: "url(#clip0_2_2)", children: [
          /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
            "path",
            {
              d: "M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24Z",
              fill: "#0DC143"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
            "path",
            {
              d: "M34.7507 13.2115C32.1777 10.5628 28.621 9.125 24.9885 9.125C17.2696 9.125 11.0642 15.4061 11.1399 23.0493C11.1399 25.4709 11.821 27.8169 12.9561 29.9358L10.9885 37.125L18.3291 35.2331C20.3723 36.3682 22.6426 36.898 24.9128 36.898C32.5561 36.898 38.7615 30.6169 38.7615 22.9736C38.7615 19.2655 37.3237 15.7845 34.7507 13.2115ZM24.9885 34.552C22.9453 34.552 20.902 34.0223 19.1615 32.9628L18.7074 32.7358L14.3183 33.8709L15.4534 29.5574L15.1507 29.1034C11.821 23.7304 13.4101 16.6169 18.8588 13.2872C24.3074 9.95743 31.3453 11.5466 34.675 16.9953C38.0047 22.4439 36.4156 29.4818 30.9669 32.8115C29.2264 33.9466 27.1074 34.552 24.9885 34.552ZM31.648 26.152L30.8156 25.7736C30.8156 25.7736 29.6047 25.2439 28.848 24.8655C28.7723 24.8655 28.6966 24.7899 28.621 24.7899C28.3939 24.7899 28.2426 24.8655 28.0912 24.9412C28.0912 24.9412 28.0156 25.0169 26.9561 26.2277C26.8804 26.3791 26.7291 26.4547 26.5777 26.4547H26.502C26.4264 26.4547 26.275 26.3791 26.1993 26.3034L25.821 26.152C24.9885 25.7736 24.2318 25.3196 23.6264 24.7142C23.475 24.5628 23.248 24.4115 23.0966 24.2601C22.5669 23.7304 22.0372 23.125 21.6588 22.4439L21.5831 22.2926C21.5074 22.2169 21.5074 22.1412 21.4318 21.9899C21.4318 21.8385 21.4318 21.6872 21.5074 21.6115C21.5074 21.6115 21.8101 21.2331 22.0372 21.0061C22.1885 20.8547 22.2642 20.6277 22.4156 20.4764C22.5669 20.2493 22.6426 19.9466 22.5669 19.7196C22.4912 19.3412 21.5831 17.298 21.3561 16.8439C21.2047 16.6169 21.0534 16.5412 20.8264 16.4655H20.5993C20.448 16.4655 20.221 16.4655 19.9939 16.4655C19.8426 16.4655 19.6912 16.5412 19.5399 16.5412L19.4642 16.6169C19.3128 16.6926 19.1615 16.8439 19.0101 16.9196C18.8588 17.0709 18.7831 17.2223 18.6318 17.3736C18.102 18.0547 17.7993 18.8872 17.7993 19.7196C17.7993 20.325 17.9507 20.9304 18.1777 21.4601L18.2534 21.6872C18.9345 23.125 19.8426 24.4115 21.0534 25.5466L21.3561 25.8493C21.5831 26.0764 21.8101 26.2277 21.9615 26.4547C23.5507 27.8169 25.3669 28.8007 27.4101 29.3304C27.6372 29.4061 27.9399 29.4061 28.1669 29.4818C28.3939 29.4818 28.6966 29.4818 28.9237 29.4818C29.302 29.4818 29.7561 29.3304 30.0588 29.1791C30.2858 29.0277 30.4372 29.0277 30.5885 28.8764L30.7399 28.725C30.8912 28.5736 31.0426 28.498 31.1939 28.3466C31.3453 28.1953 31.4966 28.0439 31.5723 27.8926C31.7237 27.5899 31.7993 27.2115 31.875 26.8331C31.875 26.6818 31.875 26.4547 31.875 26.3034C31.875 26.3034 31.7993 26.2277 31.648 26.152Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime75.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)("clipPath", { id: "clip0_2_2", children: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)("rect", { width: "48", height: "48", fill: "white" }) }) })
      ]
    })
  );
}
var WhatsAppIcon_default = WhatsAppIcon;

// src/loading/Loading.tsx
var import_jsx_runtime76 = require("react/jsx-runtime");
function Loading({ className = {} }) {
  var _a, _b;
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
    "div",
    {
      className: ` w-full flex justify-center  ${(_a = className == null ? void 0 : className.container) != null ? _a : "h-screen"}`,
      children: /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)("div", { className: "flex h-full opacity-70 z-30 pb-44  m-auto", children: [
        /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
          SpinnerIcon_default,
          {
            className: `m-auto w-24 h-24 animate-spin text-gray-200 fill-purple-300 ${(_b = className == null ? void 0 : className.spinner) != null ? _b : ""} `
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("span", { className: "sr-only", children: "Loading..." })
      ] })
    }
  );
}
var Loading_default = Loading;

// src/card/Card.tsx
var import_jsx_runtime77 = require("react/jsx-runtime");
function Card(_a) {
  var _b = _a, {
    children,
    className = ""
  } = _b, props = __objRest(_b, [
    "children",
    "className"
  ]);
  var _a2;
  return /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
    "div",
    __spreadProps(__spreadValues({
      className: `relative flex flex-col min-w-0 bg-white bg-clip-border shadow-[0_4px_10px_rgba(0,0,0,0.10)] rounded-lg ${className}`,
      style: __spreadValues({
        wordWrap: "break-word"
      }, (_a2 = props.style) != null ? _a2 : {})
    }, props), {
      children
    })
  );
}

// src/card/CardBody.tsx
var import_jsx_runtime78 = require("react/jsx-runtime");
function CardBody({ children, className = "" }) {
  return /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
    "div",
    {
      className: `px-5 md:px-10 py-8 flex flex-col flex-auto gap-5 ${className}`,
      children
    }
  );
}

// src/card/CardHeader.tsx
var import_jsx_runtime79 = require("react/jsx-runtime");
function CardHeader({
  children,
  className = ""
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(import_jsx_runtime79.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("div", { className: `px-6 py-2 ${className}`, children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("h2", { className: "text-gray-300 flex justify-between uppercase", children }) }),
    /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("hr", { className: `w-full h-[0.5px] bg-neutral-200  ${className}` })
  ] });
}

// src/card/CardSubHeader.tsx
var import_jsx_runtime80 = require("react/jsx-runtime");
function CardSubHeader({
  children,
  className = ""
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("div", { className: ` ${className}`, children: /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)("p", { className: "text-neutral-200 text-sm font-semibold pb-6", children: [
    " ",
    children,
    " "
  ] }) });
}

// src/card/index.ts
var card_default = Object.assign(Card, {
  Header: CardHeader,
  SubHeader: CardSubHeader,
  Body: CardBody
});

// src/table/Table.tsx
var import_react2 = __toESM(require("react"));
var import_react_table = require("@tanstack/react-table");
var import_match_sorter_utils = require("@tanstack/match-sorter-utils");

// src/Alert.tsx
var import_jsx_runtime81 = require("react/jsx-runtime");
function Alert({
  title,
  text,
  show = false,
  className = "",
  titleClassName = "",
  textClassName = ""
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime81.jsx)("div", { children: show ? /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
    "div",
    {
      className: `bg-purple-50 rounded-b text-teal-900 px-4 py-3 shadow-md ${className}`,
      role: "alert",
      children: /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)("div", { className: "flex", children: [
        /* @__PURE__ */ (0, import_jsx_runtime81.jsx)("div", { className: "py-1", children: /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(InfoIcon_default, { className: "w-4 h-4 text-purple-300 mr-2" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)("div", { children: [
          /* @__PURE__ */ (0, import_jsx_runtime81.jsx)("p", { className: `font-bold text-purple-300 ${titleClassName}`, children: title }),
          /* @__PURE__ */ (0, import_jsx_runtime81.jsx)("p", { className: `text-sm text-text-gray ${textClassName}`, children: text })
        ] })
      ] })
    }
  ) : null });
}
var Alert_default = Alert;

// src/table/Table.tsx
var import_jsx_runtime82 = require("react/jsx-runtime");
function generateContext() {
  return import_react2.default.createContext({
    hook: null,
    globalFilter: "",
    setGlobalFilter: () => {
    }
  });
}
var TableContext = null;
var fuzzyFilter = (row, columnId, value, addMeta) => {
  const itemRank = (0, import_match_sorter_utils.rankItem)(row.getValue(columnId), value);
  addMeta({
    itemRank
  });
  return itemRank.passed;
};
function TableContextProvider({
  children,
  data,
  columns,
  manualPagination = false,
  visibility = {}
}) {
  var _a;
  TableContext = generateContext();
  const [globalFilter, setGlobalFilter] = import_react2.default.useState("");
  const hook = (0, import_react_table.useReactTable)({
    data,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter
    },
    state: {
      // columnFilters,
      globalFilter,
      columnVisibility: visibility
    },
    meta: {
      lengthOfData: (_a = data == null ? void 0 : data.length) != null ? _a : 0
    },
    // onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: (0, import_react_table.getCoreRowModel)(),
    getFilteredRowModel: (0, import_react_table.getFilteredRowModel)(),
    getSortedRowModel: (0, import_react_table.getSortedRowModel)(),
    getPaginationRowModel: (0, import_react_table.getPaginationRowModel)(),
    getFacetedRowModel: (0, import_react_table.getFacetedRowModel)(),
    getFacetedUniqueValues: (0, import_react_table.getFacetedUniqueValues)(),
    getFacetedMinMaxValues: (0, import_react_table.getFacetedMinMaxValues)(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
    manualPagination
  });
  const value = import_react2.default.useMemo(
    () => ({
      hook,
      globalFilter,
      setGlobalFilter
    }),
    [globalFilter, hook]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(TableContext.Provider, { value, children });
}
function useTable() {
  const { hook } = (0, import_react2.useContext)(TableContext);
  return hook;
}
function useGlobalFilter() {
  const { globalFilter, setGlobalFilter } = (0, import_react2.useContext)(
    TableContext
  );
  return [globalFilter, setGlobalFilter];
}
function TableComponent({
  href,
  children,
  data,
  columns,
  manualPagination = false,
  visibility = {}
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime82.jsxs)(
    TableContextProvider,
    {
      data: (data == null ? void 0 : data.length) > 0 ? data : [],
      columns,
      visibility,
      manualPagination,
      children: [
        children,
        /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
          Alert_default,
          {
            title: "No se encontraron resultados",
            text: "No hemos encontrado resultados para la busqueda solicitada",
            show: (data == null ? void 0 : data.length) === 0
          }
        )
      ]
    }
  );
}

// src/Button.tsx
var import_jsx_runtime83 = require("react/jsx-runtime");
function Button(_a) {
  var _b = _a, {
    className,
    children
  } = _b, props = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
    "button",
    __spreadProps(__spreadValues({
      className: `py-2 px-4 bg-purple-300 rounded w-full font-semibold tracking-wide transition-colors
      ${!(className == null ? void 0 : className.includes("text")) && "text-white"}
      ${!(className == null ? void 0 : className.includes("bg")) && "bg-purple-300"}
      ${className}`
    }, props), {
      children
    })
  );
}

// src/table/TableAddButton.tsx
var import_jsx_runtime84 = require("react/jsx-runtime");
function AddButton({ title, action }) {
  return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("div", { className: "", children: /* @__PURE__ */ (0, import_jsx_runtime84.jsxs)(
    Button,
    {
      className: "ml-auto h-10 font-normal flex",
      onClick: (e) => {
        e.preventDefault();
        action();
      },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(AddIcon_default, { className: "h-4 w-4 my-auto mr-2 " }),
        /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("span", { className: "text-sm my-auto", children: title })
      ]
    }
  ) });
}
var TableAddButton_default = AddButton;

// src/table/TableContent.tsx
var import_react_table2 = require("@tanstack/react-table");
var import_jsx_runtime85 = require("react/jsx-runtime");
function TableContent({
  onClickRow: onClick,
  onKeyDownOrUpRow: onKeyDownOrUp
}) {
  const table = useTable();
  if (table.getRowModel().rows.length === 0)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("div", { className: "block w-full overflow-x-auto", children: /* @__PURE__ */ (0, import_jsx_runtime85.jsxs)("table", { className: "items-center w-full bg-transparent border-collapse", children: [
    /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("thead", { className: "", children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("tr", { children: headerGroup.headers.map((header) => /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
      "th",
      {
        className: "px-6 align-middle py-3 text-xs uppercase whitespace-nowrap font-semibold text-left  text-neutral-warm-500 ",
        children: header.isPlaceholder ? null : (0, import_react_table2.flexRender)(
          header.column.columnDef.header,
          header.getContext()
        )
      },
      header.id
    )) }, headerGroup.id)) }),
    /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("tbody", { children: table.getRowModel().rows.map((row) => /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
      "tr",
      {
        role: "button",
        tabIndex: 0,
        className: "cursor-pointer ",
        "data-id": row.original._id,
        onClick,
        onKeyDown: onKeyDownOrUp,
        onKeyUp: onKeyDownOrUp,
        children: row.getVisibleCells().map((cell) => /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
          "td",
          {
            className: "border-t-0 px-6 align-middle border-l-0 border-r-0  whitespace-nowrap p-4 text-text-black",
            children: (0, import_react_table2.flexRender)(cell.column.columnDef.cell, cell.getContext())
          },
          cell.id
        ))
      },
      row.id
    )) })
  ] }) });
}

// src/table/TableFooter.tsx
var import_jsx_runtime86 = require("react/jsx-runtime");
function TableFooter(_a) {
  var _b = _a, {
    children,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime86.jsx)("div", __spreadProps(__spreadValues({ className: ` ${className}` }, props), { children: /* @__PURE__ */ (0, import_jsx_runtime86.jsx)("div", { className: "flex flex-wrap items-center", children }) }));
}

// src/table/TableHeader.tsx
var import_jsx_runtime87 = require("react/jsx-runtime");
function TableHeader(_a) {
  var _b = _a, {
    children,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(
    "div",
    __spreadProps(__spreadValues({
      className: `p-6 w-full flex flex-col md:flex-row justify-between gap-2 ${className} relative`
    }, props), {
      children
    })
  );
}

// src/table/TablePagination.tsx
var import_react3 = __toESM(require("react"));
var import_outline = require("@heroicons/react/24/outline");

// src/utils/calculatePagination.ts
function calculatePagination({
  pageInfo
}) {
  const { currentPage, perPage, itemCount: count } = pageInfo;
  const current = currentPage * perPage - perPage + 1;
  const limit = currentPage * perPage - perPage + perPage <= count ? currentPage * perPage - perPage + perPage : count;
  const total = count;
  return {
    current,
    limit,
    total
  };
}

// src/table/TablePagination.tsx
var import_jsx_runtime88 = require("react/jsx-runtime");
function TablePagination(_a) {
  var _b = _a, {
    className = "",
    handleGoToPage = () => {
    },
    paginationInfo
  } = _b, props = __objRest(_b, [
    "className",
    "handleGoToPage",
    "paginationInfo"
  ]);
  var _a2;
  const table = useTable();
  const [isManualPagination] = import_react3.default.useState(
    (_a2 = table.options.manualPagination) != null ? _a2 : false
  );
  const paginationRange = import_react3.default.useMemo(
    () => table.options.manualPagination ? calculatePagination(paginationInfo) : {
      current: table.getRowModel().rows.length ? table.getRowModel().rows[0].index + 1 : 0,
      limit: table.getRowModel().rows.length ? table.getRowModel().rows[table.getRowModel().rows.length - 1].index + 1 : 0,
      total: table.getRowCount()
    },
    [paginationInfo]
  );
  const handleGoToFirstPage = () => {
    if (isManualPagination) {
      handleGoToPage(1);
    } else {
      table.setPageIndex(0);
    }
  };
  const handleGoToLastPage = () => {
    if (isManualPagination)
      handleGoToPage(paginationInfo.pageInfo.pageCount);
    else if (!isManualPagination) {
      table.setPageIndex(table.getPageCount() - 1);
    }
  };
  const handleGoToNextPage = () => {
    var _a3;
    if (isManualPagination && ((_a3 = paginationInfo.pageInfo) == null ? void 0 : _a3.hasNextPage))
      handleGoToPage((paginationInfo == null ? void 0 : paginationInfo.pageInfo.currentPage) + 1);
    else if (!isManualPagination) {
      table.nextPage();
    }
  };
  const handleGoToPrevPage = () => {
    var _a3;
    if (isManualPagination && ((_a3 = paginationInfo == null ? void 0 : paginationInfo.pageInfo) == null ? void 0 : _a3.hasPreviousPage))
      handleGoToPage((paginationInfo == null ? void 0 : paginationInfo.pageInfo.currentPage) - 1);
    else if (!isManualPagination) {
      table.previousPage();
    }
  };
  if (table.getRowModel().rows.length === 0)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("div", __spreadProps(__spreadValues({ className: `py-2 ${className}` }, props), { children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("nav", { className: "block", children: /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)("ul", { className: "flex pl-0 rounded list-none flex-wrap items-center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)("li", { className: "text-gray-300", children: [
      paginationRange == null ? void 0 : paginationRange.current,
      " al ",
      paginationRange == null ? void 0 : paginationRange.limit,
      " de",
      " ",
      paginationRange == null ? void 0 : paginationRange.total
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("li", { className: "", children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
      "button",
      {
        "aria-label": "Go to first page",
        type: "button",
        className: "first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative text-slate-500",
        onClick: handleGoToFirstPage,
        disabled: isManualPagination ? !paginationInfo.pageInfo.hasPreviousPage : !table.getCanPreviousPage(),
        children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(import_outline.ChevronDoubleLeftIcon, { className: "w-4 h-4" })
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("li", { className: "", children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
      "button",
      {
        "aria-label": "Go to previous page",
        type: "button",
        className: "first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0  items-center justify-center leading-tight relative  text-slate-500",
        onClick: handleGoToPrevPage,
        disabled: isManualPagination ? !paginationInfo.pageInfo.hasPreviousPage : !table.getCanPreviousPage(),
        children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(import_outline.ChevronLeftIcon, { className: "w-4 h-4" })
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("li", { className: "", children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
      "button",
      {
        "aria-label": "Go to next page",
        type: "button",
        className: "first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0  items-center justify-center leading-tight relative  text-slate-500 ",
        onClick: handleGoToNextPage,
        disabled: isManualPagination ? !paginationInfo.pageInfo.hasNextPage : !table.getCanNextPage(),
        children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(import_outline.ChevronRightIcon, { className: "w-4 h-4" })
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("li", { className: "", children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
      "button",
      {
        "aria-label": "Go to last page",
        type: "button",
        className: "first:ml-0 text-xs font-semibold flex w-8 h-8 mx-1 p-0 rounded-full items-center justify-center leading-tight relative  text-slate-500",
        onClick: handleGoToLastPage,
        disabled: isManualPagination ? !paginationInfo.pageInfo.hasNextPage : !table.getCanNextPage(),
        children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(import_outline.ChevronDoubleRightIcon, { className: "w-4 h-4" })
      }
    ) })
  ] }) }) }));
}

// src/table/TableSearchInput.tsx
var import_react4 = __toESM(require("react"));
var import_jsx_runtime89 = require("react/jsx-runtime");
function DebouncedInput(_a) {
  var _b = _a, {
    value: initialValue,
    onChange,
    debounce = 500
  } = _b, props = __objRest(_b, [
    "value",
    "onChange",
    "debounce"
  ]);
  const [value, setValue] = import_react4.default.useState(initialValue);
  import_react4.default.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  import_react4.default.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);
    return () => clearTimeout(timeout);
  }, [value]);
  return /* @__PURE__ */ (0, import_jsx_runtime89.jsxs)(
    "div",
    {
      className: `md:w-[300px] border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 `,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(SearchIcon_default, { className: "w-5 h-5 text-neutral-400" }),
        /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(
          "input",
          __spreadValues({
            value,
            onChange: (e) => setValue(e.target.value)
          }, props)
        )
      ]
    }
  );
}
function TableSearchInput(_a) {
  var _b = _a, {
    className = "",
    manualFilter = false,
    value,
    onChange
  } = _b, props = __objRest(_b, [
    "className",
    "manualFilter",
    "value",
    "onChange"
  ]);
  const [globalFilter, setGlobalFilter] = useGlobalFilter();
  const debouncedInputChange = () => {
    if (manualFilter) {
      return onChange;
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(
    DebouncedInput,
    __spreadValues({
      value: manualFilter ? value : globalFilter,
      onChange: manualFilter ? onChange : (_value) => setGlobalFilter(String(_value)),
      className: `mt-0 block w-full  focus:ring-0  border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none  placeholder:text-neutral-400 text-text-black tracking-wider p-0 ${className}`,
      placeholder: "Buscar",
      type: "search"
    }, props)
  );
}

// src/table/index.ts
var table_default = Object.assign(TableComponent, {
  Content: TableContent,
  AddButton: TableAddButton_default,
  Footer: TableFooter,
  Header: TableHeader,
  Pagination: TablePagination,
  SearchInput: TableSearchInput
});

// src/modal/ModalTitle.tsx
var import_jsx_runtime90 = require("react/jsx-runtime");
function ModalTitle({ setIsOpen, title }) {
  return /* @__PURE__ */ (0, import_jsx_runtime90.jsxs)("div", { className: "flex justify-between items-center border-b px-6 py-3", children: [
    /* @__PURE__ */ (0, import_jsx_runtime90.jsx)("h2", { className: "text-xl text-text-gray font-semibold", children: title }),
    /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(
      "button",
      {
        type: "button",
        "aria-label": "close",
        onClick: (e) => {
          e.preventDefault();
          setIsOpen(false);
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(CloseIcon_default, { className: "h-5 w-5 text-red-500" })
      }
    )
  ] });
}
var ModalTitle_default = ModalTitle;

// src/modal/Modal.tsx
var import_react5 = __toESM(require("react"));
var import_react6 = require("@headlessui/react");
var import_jsx_runtime91 = require("react/jsx-runtime");
function Modal({
  isOpen,
  setOpen,
  title,
  children,
  className,
  onClose
}) {
  const closeModal = () => {
    setOpen(false);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(import_react6.Transition, { appear: true, show: isOpen, as: import_react5.default.Fragment, children: /* @__PURE__ */ (0, import_jsx_runtime91.jsxs)(
    import_react6.Dialog,
    {
      as: "div",
      className: "relative z-50 overflow-y-auto",
      onClose: onClose != null ? onClose : closeModal,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
          import_react6.Transition.Child,
          {
            as: import_react5.default.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
              "div",
              {
                className: "fixed inset-0 bg-black bg-opacity-25",
                style: {
                  opacity: 0.25
                }
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime91.jsx)("div", { className: "fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ (0, import_jsx_runtime91.jsx)("div", { className: "flex min-h-full items-center justify-center p-4 text-center", children: /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
          import_react6.Transition.Child,
          {
            as: import_react5.default.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /* @__PURE__ */ (0, import_jsx_runtime91.jsxs)(
              import_react6.Dialog.Panel,
              {
                className: `w-full max-w-[36rem] transform overflow-hidden text-left align-middle shadow-xl transition-all rounded-tr rounded-br ${className}`,
                children: [
                  title ? /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
                    import_react6.Dialog.Title,
                    {
                      as: "h3",
                      className: "text-lg font-medium leading-6 text-gray-900",
                      children: title
                    }
                  ) : null,
                  children
                ]
              }
            )
          }
        ) }) })
      ]
    }
  ) });
}
var Modal_default = Modal;

// src/modal/index.ts
var modal_default = Object.assign(Modal_default, {
  Title: ModalTitle_default
});

// src/input/Input.tsx
var import_react7 = __toESM(require("react"));
var import_jsx_runtime92 = require("react/jsx-runtime");
var Input = import_react7.default.forwardRef(
  function _Input(_a, ref) {
    var _b = _a, {
      label = "",
      children,
      rightIcon,
      className = "",
      onChange,
      placeholder,
      fullWidth
    } = _b, props = __objRest(_b, [
      "label",
      "children",
      "rightIcon",
      "className",
      "onChange",
      "placeholder",
      "fullWidth"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime92.jsxs)("label", { className: `block ${fullWidth ? "w-full" : ""}`, children: [
      label !== "" ? /* @__PURE__ */ (0, import_jsx_runtime92.jsx)("span", { className: "text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ", children: label }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime92.jsxs)(
        "div",
        {
          className: `w-full border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 ${className}`,
          children: [
            children,
            /* @__PURE__ */ (0, import_jsx_runtime92.jsx)(
              "input",
              __spreadValues({
                className: `${label !== "" ? " " : ""} focus:ring-0 border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none w-full placeholder:text-neutral-400 text-text-black tracking-wider p-0 ${className}`,
                ref,
                onChange,
                placeholder
              }, props)
            ),
            rightIcon
          ]
        }
      )
    ] });
  }
);

// src/input/Select.tsx
var import_react8 = __toESM(require("react"));
var import_jsx_runtime93 = require("react/jsx-runtime");
var Select = import_react8.default.forwardRef(
  function _Select(_a, ref) {
    var _b = _a, { label = "", onChange, defaultSelect, className = "", children } = _b, props = __objRest(_b, ["label", "onChange", "defaultSelect", "className", "children"]);
    return /* @__PURE__ */ (0, import_jsx_runtime93.jsxs)("label", { className: "block", children: [
      label !== "" ? /* @__PURE__ */ (0, import_jsx_runtime93.jsx)("span", { className: "text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ", children: label }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(
        "select",
        __spreadProps(__spreadValues({
          ref,
          defaultValue: defaultSelect,
          onChange,
          className: `border-[0.5px] text-gray-300  border-solid border-neutral-300  appearance-none outline-none block w-full rounded py-2 px-3 placeholder:text-neutral-100  ${className}`
        }, props), {
          children
        })
      )
    ] });
  }
);

// src/input/TextArea.tsx
var import_react9 = __toESM(require("react"));
var import_jsx_runtime94 = require("react/jsx-runtime");
var TextArea = import_react9.default.forwardRef(
  function _TextArea(_a, ref) {
    var _b = _a, { label = "", className = "", onChange } = _b, props = __objRest(_b, ["label", "className", "onChange"]);
    return /* @__PURE__ */ (0, import_jsx_runtime94.jsxs)("label", { className: "block", children: [
      label !== "" ? /* @__PURE__ */ (0, import_jsx_runtime94.jsx)("span", { className: "text-neutral-200 text-sm font-medium mb-2", children: label }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(
        "textarea",
        __spreadValues({
          className: `${label !== "" ? " " : ""} border-[0.5px] border-solid border-neutral-100 appearance-none outline-none block w-full rounded py-2 px-3 placeholder:text-neutral-100  ${className}`,
          ref,
          onChange
        }, props)
      )
    ] });
  }
);

// src/input/AmountInput.tsx
var import_react10 = require("react");
var import_jsx_runtime95 = require("react/jsx-runtime");
var AmountInput = ({ onChange }) => {
  const [rawValue, setRawValue] = (0, import_react10.useState)("");
  const inputRef = (0, import_react10.useRef)(null);
  (0, import_react10.useEffect)(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const formatAmount = (value) => {
    if (!value)
      return "0.00";
    const numericValue = parseInt(value, 10) || 0;
    return (numericValue / 100).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  const handleChange = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    if (value.length > 1 && value.startsWith("0")) {
      value = value.replace(/^0+/, "");
    }
    setRawValue(value);
    if (onChange) {
      onChange(formatAmount(value));
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime95.jsxs)("label", { className: "block w-full", children: [
    /* @__PURE__ */ (0, import_jsx_runtime95.jsx)("span", { className: "text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ", children: "Monto" }),
    /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(
      "div",
      {
        className: `w-full border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 `,
        children: /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(
          "input",
          {
            type: "text",
            value: formatAmount(rawValue),
            onChange: handleChange,
            ref: inputRef,
            style: { textAlign: "right" },
            placeholder: "0.00",
            name: "PM_AMOUNT",
            className: "focus:ring-0 border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none w-full placeholder:text-neutral-400 text-text-black tracking-wider p-0 "
          }
        )
      }
    )
  ] });
};

// src/input/DniInput.tsx
var import_jsx_runtime96 = require("react/jsx-runtime");
function DniInput(_a) {
  var _b = _a, {
    label,
    className = "",
    handleChange,
    handleChangeSelect,
    children,
    inputName,
    selectName,
    placeholder,
    defaultSelect,
    inputValue,
    selectValue,
    disabled = false,
    reducerId = ""
  } = _b, props = __objRest(_b, [
    "label",
    "className",
    "handleChange",
    "handleChangeSelect",
    "children",
    "inputName",
    "selectName",
    "placeholder",
    "defaultSelect",
    "inputValue",
    "selectValue",
    "disabled",
    "reducerId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime96.jsxs)("div", { className: "w-full ", children: [
    /* @__PURE__ */ (0, import_jsx_runtime96.jsx)("span", { className: "text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ", children: label }),
    /* @__PURE__ */ (0, import_jsx_runtime96.jsxs)("div", { className: "flex flex-row w-full", children: [
      /* @__PURE__ */ (0, import_jsx_runtime96.jsx)("div", { className: "w-16", children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
        Select,
        {
          className: `rounded-r-none rounded  ${className}`,
          onChange: handleChangeSelect,
          label: "",
          name: selectName,
          value: selectValue,
          "data-id": reducerId,
          disabled,
          children
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime96.jsx)("div", { className: "w-full", children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
        Input,
        {
          label: "",
          type: "text",
          name: inputName,
          className: `rounded-l-none border-l-0 w-full ${className}`,
          onChange: handleChange,
          placeholder,
          value: inputValue,
          "data-id": reducerId,
          disabled,
          step: 1
        }
      ) })
    ] })
  ] });
}

// src/input/MultipleSelect.tsx
var import_react11 = __toESM(require("react"));
var import_react12 = require("@headlessui/react");
var import_outline2 = require("@heroicons/react/24/outline");
var import_jsx_runtime97 = require("react/jsx-runtime");
function MultipleSelect(_a) {
  var _b = _a, {
    label,
    onChangeSelect,
    options,
    defaultSelect = [],
    className = "",
    actionName,
    description,
    resetSelection = false,
    setResetSelection
  } = _b, props = __objRest(_b, [
    "label",
    "onChangeSelect",
    "options",
    "defaultSelect",
    "className",
    "actionName",
    "description",
    "resetSelection",
    "setResetSelection"
  ]);
  const popupRef = import_react11.default.useRef(null);
  const buttonRef = import_react11.default.useRef(null);
  const [isOpen, setIsOpen] = import_react11.default.useState(false);
  const [selectedOptions, setSelectedOptions] = import_react11.default.useState([]);
  const [defaultOptions, setDefaultOptions] = import_react11.default.useState([]);
  import_react11.default.useEffect(() => {
    function handleClickOutside(event) {
      var _a2;
      if (popupRef.current && !popupRef.current.contains(event.target) && !((_a2 = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a2.contains(event.target))) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  function isSelectedOptions(value) {
    return !!selectedOptions.find((el) => el._id === value._id);
  }
  function handleSelect(value) {
    if (!isSelectedOptions(value)) {
      const selectedOptionsUpdated = [
        ...selectedOptions,
        options.find((el) => el === value)
      ];
      setSelectedOptions(selectedOptionsUpdated);
    } else {
      handleDeselect(value);
    }
    setIsOpen(false);
  }
  function handleDeselect(value) {
    const selectedOptionsUpdated = selectedOptions.filter(
      (el) => el._id !== value._id
    );
    setSelectedOptions(selectedOptionsUpdated);
    setIsOpen(true);
  }
  import_react11.default.useEffect(() => {
    if ((defaultSelect == null ? void 0 : defaultSelect.length) > 0 && selectedOptions.length === 0 && defaultOptions.length === 0) {
      setSelectedOptions(defaultSelect);
      setDefaultOptions(defaultSelect);
    }
  }, [defaultSelect]);
  import_react11.default.useEffect(() => {
    if (resetSelection && setResetSelection) {
      setSelectedOptions([]);
      setResetSelection(false);
    }
  }, [resetSelection]);
  import_react11.default.useEffect(() => {
    onChangeSelect(selectedOptions, actionName);
  }, [selectedOptions]);
  return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("div", { className: "flex items-center justify-center w-full h-full", children: /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)("div", { className: "w-full h-full rela ", children: [
    /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("span", { className: "text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider  ", children: label }),
    /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
      import_react12.Combobox,
      {
        as: "div",
        value: selectedOptions,
        onChange: (e) => {
          handleSelect(e);
        },
        children: () => /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)("div", { className: "relative", children: [
          /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("span", { className: "block w-full  h-[42px]", children: /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(
            import_react12.Combobox.Button,
            {
              ref: buttonRef,
              className: "cursor-default relative w-full h-full rounded border-[0.5px] bg-white pl-3 pr-10 py-2 text-left border-neutral-300 transition ease-in-out duration-150 ",
              onClick: () => setIsOpen(!isOpen),
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
                  "span",
                  {
                    className: `block truncate text-gray-300   tracking-wider ${description ? " text-gray-300 " : ""}`,
                    children: selectedOptions.length < 1 ? description : `${selectedOptions.map((op) => ` ${op.name}`)}`
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("span", { className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" })
              ]
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
            import_react12.Transition,
            {
              unmount: false,
              show: isOpen,
              leave: "transition ease-in duration-100",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              ref: popupRef,
              children: /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
                import_react12.Combobox.Options,
                {
                  static: true,
                  className: "absolute w-full max-h-60 rounded py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none  sm:leading-5  mt-1 bg-white shadow-lg z-50",
                  children: options.map((option) => {
                    var _a2;
                    const selected = isSelectedOptions(option);
                    return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
                      import_react12.Combobox.Option,
                      {
                        value: option,
                        disabled: (_a2 = option.disabled) != null ? _a2 : false,
                        className: ({ active }) => `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? "bg-purple-300 text-white" : option.disabled ? "text-neutral-100 cursor-not-allowed" : "text-gray-900"}`,
                        children: ({ active }) => /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(import_jsx_runtime97.Fragment, { children: [
                          /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
                            "span",
                            {
                              className: `block truncate font-light tracking-wider  ${selected ? "font-medium" : ""}`,
                              children: option.name
                            }
                          ),
                          selected ? /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
                            "span",
                            {
                              className: `absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : "text-gray-300"}`,
                              children: /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
                                import_outline2.CheckIcon,
                                {
                                  className: "h-5 w-5",
                                  "aria-hidden": "true"
                                }
                              )
                            }
                          ) : null
                        ] })
                      },
                      option._id
                    );
                  })
                }
              )
            }
          )
        ] })
      }
    )
  ] }) });
}

// src/input/DateInput.tsx
var import_react13 = __toESM(require("react"));
var import_dayjs = __toESM(require("dayjs"));

// src/utils/calendar.ts
var WEEK_DAYS = ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"];
var months = [
  { name: "Enero", days: 31 },
  { name: "Febrero", days: 28 },
  { name: "Marzo", days: 31 },
  { name: "Abril", days: 30 },
  { name: "Mayo", days: 31 },
  { name: "Junio", days: 30 },
  { name: "Julio", days: 31 },
  { name: "Agosto", days: 31 },
  { name: "Septiembre", days: 30 },
  { name: "Octubre", days: 31 },
  { name: "Noviembre", days: 30 },
  { name: "Diciembre", days: 31 }
];
function getPreviousMonth(month, year) {
  const prevMonth = month > 0 ? month - 1 : 11;
  const prevMonthYear = month > 0 ? year : year - 1;
  return { month: prevMonth, year: prevMonthYear };
}
function getNextMonth(month, year) {
  const nextMonth = month < 11 ? month + 1 : 0;
  const nextMonthYear = month < 11 ? year : year + 1;
  return { month: nextMonth, year: nextMonthYear };
}
function refactorDate(date) {
  return `${date.slice(6, 10)}-${date.slice(3, 5)}-${date.slice(0, 2)}`;
}

// src/utils/formatCurrency.ts
function formatCurrency(candidate, decimalPoint = true) {
  if (!candidate && candidate !== 0)
    return "-";
  if (Number.isNaN(Number(candidate)))
    return "-";
  const numberFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });
  const result = numberFormat.format(Number(candidate)).replace("$", "").replace(/( )/g, "").trim();
  if (decimalPoint) {
    return result;
  }
  const [integer, decimal] = result.split(".");
  return `${integer.replace(/(,)/g, ".")},${decimal.length < 1 ? decimal : `${decimal}0`}`;
}

// src/input/DateInput.tsx
var import_jsx_runtime98 = require("react/jsx-runtime");
function DateInput({
  label,
  value,
  error,
  open = false,
  size = "small",
  setState
}) {
  var _a, _b, _c;
  const today = (_a = (0, import_dayjs.default)()) == null ? void 0 : _a.startOf("day");
  const [show, setShow] = import_react13.default.useState(open);
  const ref = import_react13.default.useRef(null);
  const [month, setMonth] = import_react13.default.useState(today.month());
  const [year, setYear] = import_react13.default.useState(today.year());
  const [days, setDays] = import_react13.default.useState([]);
  const [offset, setOffset] = import_react13.default.useState([]);
  const [hasPreviousMonth, setHasPreviousMonth] = import_react13.default.useState(true);
  const goToPreviousMonth = () => {
    const previousMonth = getPreviousMonth(month, year);
    setMonth(previousMonth.month);
    setYear(previousMonth.year);
  };
  const goToNextMonth = () => {
    const nextMonth = getNextMonth(month, year);
    setMonth(nextMonth.month);
    setYear(nextMonth.year);
  };
  import_react13.default.useEffect(
    function syncMonthData() {
      var _a2, _b2, _c2, _d;
      setDays([...Array((_a2 = months[month]) == null ? void 0 : _a2.days)]);
      setOffset([
        ...Array((_d = (_c2 = (_b2 = today == null ? void 0 : today.set("month", month)) == null ? void 0 : _b2.startOf("month")) == null ? void 0 : _c2.day()) != null ? _d : 2 - 1)
      ]);
      setHasPreviousMonth(today.month() !== month);
    },
    [month]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)("div", { className: "w-full relative", ref, children: [
    /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
      "button",
      {
        type: "button",
        className: `w-full text-sm ${open ? "hidden" : "flex"}`,
        onClick: (e) => {
          e.preventDefault();
          setShow((_show) => !_show);
        },
        children: value
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)(
      "div",
      {
        className: `flex-col justify-center items-center rounded-xl bg-white shadow-md ${!open ? "mt-5 -translate-x-1/4 absolute" : ""} ${size === "small" ? "w-72 p-6" : "w-full p-8"} ${show ? "flex" : "hidden"}`,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)(
            "div",
            {
              className: `w-full flex justify-between px-2 ${size === "medium" ? "mb-4" : ""}`,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
                  "button",
                  {
                    "aria-label": "Go to previous month",
                    disabled: !hasPreviousMonth,
                    type: "button",
                    className: ` ${!hasPreviousMonth ? "text-neutral-200" : "text-primary-700"}`,
                    onClick: (e) => {
                      e.preventDefault();
                      goToPreviousMonth();
                    },
                    children: /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(ArrowIcon_default, { className: "w-3 h-3 rotate-180" })
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)("span", { className: "text-neutral-500 font-semibold text-md", children: [
                  (_b = months[month]) == null ? void 0 : _b.name,
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime98.jsx)("span", { className: "text-primary-300", children: year })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
                  "button",
                  {
                    "aria-label": "Go to next month",
                    type: "button",
                    className: "text-primary-700",
                    onClick: (e) => {
                      e.preventDefault();
                      goToNextMonth();
                    },
                    children: /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(ArrowIcon_default, { className: "w-3 h-3" })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)("div", { className: "w-full grid grid-cols-7 mt-4  gap-3", children: [
            (_c = WEEK_DAYS) == null ? void 0 : _c.map((weekDay, index) => /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
              "p",
              {
                className: "text-neutral-100 font-semibold text-center text-sm",
                children: weekDay
              },
              `week-day-${index}`
            )),
            offset == null ? void 0 : offset.map((_, i) => /* @__PURE__ */ (0, import_jsx_runtime98.jsx)("div", {}, `offset-${i}`)),
            days == null ? void 0 : days.map((_, i) => {
              const date = (0, import_dayjs.default)(`${year}-${month + 1}-${i}`).startOf("day").add(1, "day");
              const expired = today.isAfter(date);
              const current = (0, import_dayjs.default)(refactorDate(value)).startOf("day");
              const isSelected = current.toISOString() === date.toISOString();
              return /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
                "div",
                {
                  className: "w-full flex justify-center",
                  children: /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
                    "button",
                    {
                      disabled: expired,
                      type: "button",
                      className: `text-center px-3 py-0 sm:py-1 my-2 ${expired ? "text-neutral-100 font-medium" : ""} ${isSelected && !expired ? "bg-primary-300 rounded-full text-white " : ""} ${!isSelected && !expired ? "text-neutral-400 font-medium" : ""}`,
                      onClick: (e) => {
                        e.preventDefault();
                        setState(date.format("DD/MM/YYYY"));
                        if (!open)
                          setShow(false);
                      },
                      children: i + 1
                    }
                  )
                },
                `calendar-day-${i}`
              );
            })
          ] })
        ]
      }
    )
  ] });
}

// src/input/TagsInput.tsx
var import_react14 = __toESM(require("react"));
var import_avilatek_utils = require("avilatek-utils");
var import_uuid = require("uuid");
var import_jsx_runtime99 = require("react/jsx-runtime");
function TagsInput({
  tags = [],
  updateTags,
  onError = (value) => {
  }
}) {
  const [_tags, setTags] = import_react14.default.useState([]);
  const [text, setText] = import_react14.default.useState("");
  import_react14.default.useEffect(() => {
    updateTags(_tags);
  }, [_tags, updateTags]);
  import_react14.default.useEffect(() => {
    if ((_tags == null ? void 0 : _tags.length) === 0 && (tags == null ? void 0 : tags.length) > 0) {
      setTags(tags);
    }
  }, [tags]);
  const addTag = () => {
    if ((0, import_avilatek_utils.validateString)(text) && String(text).length < 127) {
      setTags((__tags) => {
        if (__tags.length === 0) {
          return [{ text, id: (0, import_uuid.v4)() }];
        }
        const filtered = __tags.filter((tag) => tag.text !== text);
        if (filtered.length > 0) {
          return [...filtered, { text, id: (0, import_uuid.v4)() }];
        }
        return __tags;
      });
      setText("");
      return;
    }
    onError("El valor de la variante es inv\xE1lido");
  };
  const onKeyUp = (e) => {
    e.preventDefault();
    const { key } = e;
    if (key === "Enter") {
      addTag();
    }
  };
  const onChange = (e) => {
    e.preventDefault();
    setText(e.target.value);
  };
  const deleteTag = (e) => {
    e.preventDefault();
    const { id } = e.currentTarget.dataset;
    setTags(_tags.slice().filter((tag) => tag.id !== id));
  };
  return /* @__PURE__ */ (0, import_jsx_runtime99.jsxs)("div", { className: "mt-5 lg:mt-0 flex flex-col gap-4 md:flex-row md:gap-0 flex-wrap items-start bg-white text-base leading-6 w-full ", children: [
    /* @__PURE__ */ (0, import_jsx_runtime99.jsx)("ul", { className: " p-0 flex flex-row flex-wrap min-w-0 ", children: _tags.map((tag) => /* @__PURE__ */ (0, import_jsx_runtime99.jsxs)(
      "li",
      {
        className: "flex justify-between mb-1 ml-1 h-fit bg-primary-400 text-white rounded text-sm break-words ",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime99.jsx)("span", { className: "pl-2 break-words ", children: tag.text }),
          /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(
            "button",
            {
              "aria-label": "Delete",
              className: "p-0 m-auto ml-2 focus:outline-none px-1 h-full rounded-tr rounded-br bg-primary-300",
              type: "button",
              "data-id": tag.id,
              onClick: deleteTag,
              children: /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(CloseIcon_default, { className: "w-4 h-4 m-auto p-0" })
            }
          )
        ]
      },
      tag.id
    )) }),
    /* @__PURE__ */ (0, import_jsx_runtime99.jsxs)("label", { htmlFor: "text", className: "flex-1 bg-transparent w-full", children: [
      /* @__PURE__ */ (0, import_jsx_runtime99.jsx)("span", { className: "sr-only", children: "Valor de la Variante" }),
      /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(
        Input,
        {
          type: "text",
          name: "text",
          id: "text",
          className: "flex-1 ",
          placeholder: "Presione ENTER para agregar",
          onKeyUp,
          onChange,
          value: text
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime99.jsxs)("div", { className: "w-1/3 px-4 gap-2 items-center flex", children: [
      /* @__PURE__ */ (0, import_jsx_runtime99.jsx)("span", { children: "\xF3" }),
      /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(
        Button,
        {
          className: "bg-primary-400 text-white ml-4",
          onClick: addTag,
          type: "button",
          children: "Agregar"
        }
      )
    ] })
  ] });
}
var TagsInput_default = TagsInput;

// src/input/QuantityInput.tsx
var import_jsx_runtime100 = require("react/jsx-runtime");
function QuantityInput({ step, value, onChange }) {
  return /* @__PURE__ */ (0, import_jsx_runtime100.jsx)("div", { className: " w-32", children: /* @__PURE__ */ (0, import_jsx_runtime100.jsxs)("div", { className: "flex flex-row h-[2.5rem] w-full rounded-lg relative bg-transparent mt-1", children: [
    /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
      "button",
      {
        type: "button",
        className: " border-y border-l text-gray-600  border-neutral-cold-400 h-full w-20 rounded-l cursor-pointer outline-none",
        onClick: (e) => {
          e.preventDefault();
          onChange(value - step);
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime100.jsx)("span", { className: "m-auto text-2xl text-neutral-cold-400", children: "\u2212" })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime100.jsx)("span", { className: "outline-none border-y border-neutral-cold-400 flex justify-center  focus:outline-none text-center w-full font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none", children: value != null ? value : 0 }),
    /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
      "button",
      {
        type: "button",
        className: " text-gray-600 border-y border-r border-neutral-cold-400  h-full w-20 rounded-r cursor-pointer",
        onClick: (e) => {
          e.preventDefault();
          onChange(value + step);
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime100.jsx)("span", { className: "m-auto text-2xl text-neutral-cold-400 ", children: "+" })
      }
    )
  ] }) });
}
var QuantityInput_default = QuantityInput;

// src/layout/UnLoggedLayout.tsx
var import_jsx_runtime101 = require("react/jsx-runtime");
function UnLoggedLayout({
  children,
  meitBoxesImgSrc,
  meitLogoImgSrc,
  userType = "client",
  roleTranslated = "",
  bgClassName = ""
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(
    "main",
    {
      className: `relative min-h-screen w-full bg-login-allies-companies flex ${bgClassName}`,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)("section", { className: "relative z-20 w-full lg:w-1/2 mx-auto flex flex-col items-center justify-center my-5 ", children: [
          /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)("div", { className: "flex justify-center relative ", children: [
            /* @__PURE__ */ (0, import_jsx_runtime101.jsx)("img", { className: "w-44 sm:", src: meitLogoImgSrc, alt: "logo" }),
            userType !== "client" ? /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
              "span",
              {
                className: ` absolute text-xs sm:text-base bottom-0 uppercase mt-auto pb-[0.8rem] ${userType === "admin" ? "text-neutral-warm-500 -right-24 md:-right-32" : "text-purple-100 -right-20"}`,
                children: roleTranslated
              }
            ) : null
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)("div", { className: "mx-10 max-w-lg bg-system-100 flex flex-col rounded-lg p-5 sm:p-10 space-y-6", children }),
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)("div", { className: "w-full text-center mt-5", children: /* @__PURE__ */ (0, import_jsx_runtime101.jsx)("span", { className: "text-text-white ", children: "\xA9 Meit!, 2022 | Powered by Avila Tek" }) })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime101.jsx)("div", { className: "absolute w-full h-[70vh] bottom-0 overflow-hidden flex", children: /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
          "img",
          {
            className: "relative w-full h-full object-cover object-top mt-auto",
            src: meitBoxesImgSrc,
            alt: "meit-bg"
          }
        ) })
      ]
    }
  );
}
var UnLoggedLayout_default = UnLoggedLayout;

// src/cardCarouselWrapper/CardCarouselWrapper.tsx
var import_react15 = __toESM(require("react"));

// src/cardCarouselWrapper/CardCarouselControls.tsx
var import_jsx_runtime102 = require("react/jsx-runtime");
function CardCarouselControls({ scroll }) {
  return /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(import_jsx_runtime102.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime102.jsx)("div", { className: "absolute h-full flex left-[-15px] z-10", children: /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
      ArrowIcon_default,
      {
        onClick: () => scroll("left"),
        className: "w-5 h-5 my-auto transform rotate-180 cursor-pointer text-neutral-200"
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime102.jsx)("div", { className: "absolute h-full  right-[-15px] flex z-10", children: /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
      ArrowIcon_default,
      {
        onClick: () => scroll("right"),
        className: " w-5 h-5 my-auto cursor-pointer text-neutral-200"
      }
    ) })
  ] });
}
var CardCarouselControls_default = CardCarouselControls;

// src/cardCarouselWrapper/CardCarouselWrapper.tsx
var import_jsx_runtime103 = require("react/jsx-runtime");
function CardCarouselWrapper({
  children,
  cardDimension,
  elementsToShow
}) {
  const carousel = import_react15.default.useRef(null);
  const [styles, setStyles] = import_react15.default.useState({
    width: `${elementsToShow * cardDimension}px`,
    scrollSnapType: "x mandatory",
    scrollPadding: "0%"
  });
  import_react15.default.useEffect(
    function syncStyles() {
      setStyles({
        width: `${elementsToShow * cardDimension}px`,
        scrollSnapType: "x mandatory",
        scrollPadding: "0%"
      });
    },
    [elementsToShow, cardDimension]
  );
  const scroll = (direction) => {
    var _a, _b, _c, _d, _e;
    (_e = carousel == null ? void 0 : carousel.current) == null ? void 0 : _e.scrollTo({
      top: 0,
      left: direction === "left" ? ((_b = (_a = carousel == null ? void 0 : carousel.current) == null ? void 0 : _a.scrollLeft) != null ? _b : 0) - cardDimension : ((_d = (_c = carousel == null ? void 0 : carousel.current) == null ? void 0 : _c.scrollLeft) != null ? _d : 0) + cardDimension,
      behavior: "smooth"
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)("div", { className: "w-full mt-5 relative flex justify-center ", children: [
    /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(CardCarouselControls_default, { scroll }),
    /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(
      "div",
      {
        ref: carousel,
        className: "hide-scrollbar w-full flex relative overflow-x-scroll  z-0 items-center",
        style: styles,
        children
      }
    )
  ] });
}
var CardCarouselWrapper_default = CardCarouselWrapper;

// src/hooks/useRefDimensions.ts
var import_react16 = __toESM(require("react"));
function useRefDimensions(ref) {
  var _a;
  const [dimensions, setDimensions] = import_react16.default.useState({ width: 0, height: 0 });
  import_react16.default.useEffect(() => {
    if (ref == null ? void 0 : ref.current) {
      const { current } = ref;
      const boundingRect = current.getBoundingClientRect();
      const { width, height } = boundingRect;
      setDimensions({ width: Math.round(width), height: Math.round(height) });
    }
  }, [(_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.getBoundingClientRect()]);
  return dimensions;
}
var useRefDimensions_default = useRefDimensions;

// src/hooks/useScreenSize.ts
var import_react17 = __toESM(require("react"));
function useScreenSize() {
  const [screenSize, setScreenSize] = import_react17.default.useState(0);
  import_react17.default.useEffect(() => {
    function updateScreenSize() {
      setScreenSize(window.innerWidth);
    }
    window.addEventListener("resize", updateScreenSize);
    updateScreenSize();
    return () => window.removeEventListener("resize", updateScreenSize);
  }, [screenSize]);
  return { screenSize, setScreenSize };
}
var useScreenSize_default = useScreenSize;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AddIcon,
  AirBalloonIllustration,
  AllyIcon,
  AmountInput,
  ArrowBackIcon,
  ArrowIcon,
  AvilaIcon,
  BagIcon,
  BankIcon,
  BlockIcon,
  BookIcon,
  Button,
  CalendarIcon,
  Card,
  CardCarouselWrapper,
  CardIcon,
  CategoryIcon,
  CheckEmptyIcon,
  CheckFullIcon,
  ClientOnlyPortal,
  CloseIcon,
  CollapsibleArrow,
  CompanyIcon,
  DashboardIcon,
  DateInput,
  DeleteIcon,
  DniInput,
  DollarIcon,
  DotIcon,
  EditIcon,
  EmptyIllustration,
  ExitIcon,
  EyeIcon,
  FullListIcon,
  GoalIcon,
  HeartIcon,
  HomeIcon,
  InfoIcon,
  Input,
  InventoryIcon,
  LinkedinIcon,
  Loading,
  LocalOfferIcon,
  LocationIcon,
  LockIcon,
  LogoutIcon,
  MailIcon,
  MenuIcon,
  MinusIcon,
  Modal,
  MoneyIcon,
  MultipleSelect,
  PageIcon,
  PencilIcon,
  PhoneIcon,
  PhotoIcon,
  PlanIcon,
  QuantityInput,
  RefreshIcon,
  RemoveIcon,
  SaleIcon,
  SearchIcon,
  Select,
  SendIcon,
  SettingsIcon,
  ShoppingCarIcon,
  SpinnerIcon,
  StarIcon,
  SubscriptionIcon,
  SupervisorIcon,
  Table,
  TableIcon,
  TagsInput,
  TextArea,
  ThanksIcon,
  TimerIcon,
  Toast,
  ToastCloseIcon,
  ToastErrorIcon,
  ToastSuccessIcon,
  TrashIcon,
  UnLoggedLayout,
  UpdateIcon,
  UploadIcon,
  UploadImageIcon,
  UserIcon,
  VerifiedUserIcon,
  WEEK_DAYS,
  WalletIcon,
  WhatsAppIcon,
  calculatePagination,
  formatCurrency,
  getNextMonth,
  getPreviousMonth,
  months,
  refactorDate,
  useRefDimensions,
  useScreenSize
});
